/* Light Seeker Seeds — Strain Encyclopedia
   Loaded as a separate asset so the section file stays under Shopify's 256 KB limit.
   This file contains only reference strain data; product data is generated by the section's Liquid loop. */

window.LSS_REFERENCE = window.LSS_REFERENCE || [];

/* ── BATCH 1 — HERITAGE ENCYCLOPEDIA ────────────────────────── */
window.LSS_REFERENCE = window.LSS_REFERENCE.concat([

  { id:"wedding-cake", name:"Wedding Cake", aka:"Pink Cookies, Triangle Mints #23", type:"hybrid",
    parents:["Triangle Kush","Animal Mints"],
    grandparents:{"Triangle Kush":["OG Kush","Florida OG"],"Animal Mints":["Animal Cookies","SinMint Cookies"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Seed Junky Genetics", origin:"Los Angeles, CA — 2015",
    terpenes:["Limonene","Caryophyllene","Myrcene"],
    effects:["Relaxed","Euphoric","Happy","Tingly"],
    flavors:["Sweet","Vanilla","Earthy","Pepper"],
    medical:["Pain","Stress","Insomnia","Appetite Loss"],
    desc:"A Southern California staple known for its rich tangy aroma reminiscent of cake batter and crushed peppercorn. Wedding Cake delivers a heavy, calming euphoria layered over substantial body relaxation, making it a staple for evening use. The dense, frosted buds produce well in any environment but reward growers who control humidity carefully through late flower." },

  { id:"triangle-kush", name:"Triangle Kush", aka:"TK, Triangle, Florida Triangle", type:"indica",
    parents:["OG Kush"], grandparents:{"OG Kush":["Chemdawg","Hindu Kush"]},
    thc:"20-23%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Unknown (Florida growers)", origin:"Florida, USA — late 1990s",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Earthy","Pine","Fuel","Lemon"],
    medical:["Pain","Stress","Insomnia","Anxiety"],
    desc:"Named for the three Florida cities where it took root — Jacksonville, Miami, and Tampa — Triangle Kush is one of the most influential OG cuts in modern breeding. It carries the classic fuel-and-lemon Kush profile with a heavier body presence than West Coast OGs, and shows up as a parent in Wedding Cake, 24K Gold, and dozens of premium hybrids." },

  { id:"animal-mints", name:"Animal Mints", aka:"AM", type:"hybrid",
    parents:["Animal Cookies","SinMint Cookies"],
    grandparents:{"Animal Cookies":["Girl Scout Cookies","Fire OG"],"SinMint Cookies":["GSC","Blue Power"]},
    thc:"22-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Seed Junky Genetics", origin:"USA — mid-2010s",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Euphoric","Happy","Sleepy"],
    flavors:["Mint","Cookie","Sweet","Earthy"],
    medical:["Stress","Pain","Insomnia"],
    desc:"A sharp, mint-forward cookie cross from Seed Junky that hits hard from the first inhale. Animal Mints became a foundational parent in the modern dessert era of breeding, contributing its dense bud structure and creamy mint terpenes to Wedding Cake and other heavy hitters." },

  { id:"wedding-crasher", name:"Wedding Crasher", aka:"WC", type:"hybrid",
    parents:["Wedding Cake","Purple Punch"],
    grandparents:{"Wedding Cake":["Triangle Kush","Animal Mints"],"Purple Punch":["Larry OG","Granddaddy Purple"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Symbiotic Genetics", origin:"California — 2018",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Relaxed","Uplifted","Euphoric"],
    flavors:["Grape","Vanilla","Sweet","Fruit"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"A grape-and-vanilla cocktail with a smoother, more balanced lift than its parents alone. Wedding Crasher built its reputation in the boutique California flower market for showy, color-shifting buds and an effects profile that works for both day and evening." },

  { id:"hawaiian", name:"Hawaiian", aka:"Hawaiian Sativa", type:"sativa",
    parents:["Hawaiian Landrace"], grandparents:{"Hawaiian Landrace":["Landrace"]},
    thc:"15-20%", cbd:"<0.5%", flowering:"77-91 days",
    breeder:"Landrace", origin:"Hawaiian Islands",
    terpenes:["Limonene","Pinene","Myrcene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Tropical","Pineapple","Citrus","Sweet"],
    medical:["Fatigue","Depression","Stress"],
    desc:"A pure-sativa landrace from the Hawaiian Islands, where decades of isolation produced plants with bright tropical aromas and long-lasting cerebral effects. Hawaiian genetics show up in countless modern hybrids whenever a breeder wants to add a sweet pineapple top-note and an uplifting, productive head high." },

  { id:"sour-diesel", name:"Sour Diesel", aka:"Sour D, ECSD, East Coast Sour Diesel", type:"sativa",
    parents:["Chemdawg 91","Super Skunk"],
    grandparents:{"Chemdawg 91":["Unknown Thai","Unknown Afghan"],"Super Skunk":["Skunk #1","Afghani"]},
    thc:"19-25%", cbd:"<0.3%", flowering:"77-84 days",
    breeder:"AJ (attributed)", origin:"East Coast USA — early 1990s",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Energetic","Euphoric","Uplifted","Creative"],
    flavors:["Diesel","Pungent","Citrus","Earthy"],
    medical:["Depression","Stress","Pain","Fatigue"],
    desc:"The defining East Coast sativa. Sour Diesel hits fast and clean, with the unmistakable smell of fuel that gave it its name. Its long flowering time and stretchy growth pattern have always made it a commitment to grow, but the payoff is a classic dreamy, productive high that has earned it permanent residency in the canon." },

  { id:"og-kush", name:"OG Kush", aka:"Ocean Grown Kush, Original Gangster", type:"hybrid",
    parents:["Chemdawg","Hindu Kush"],
    grandparents:{"Chemdawg":["Unknown Thai","Unknown Afghan"],"Hindu Kush":["Hindu Kush Landrace"]},
    thc:"20-26%", cbd:"<0.3%", flowering:"56-63 days",
    breeder:"Matt Berger / Josh D (attributed)", origin:"San Fernando Valley, CA — early 1990s",
    terpenes:["Myrcene","Limonene","Caryophyllene"],
    effects:["Euphoric","Relaxed","Happy","Uplifted"],
    flavors:["Earthy","Pine","Lemon","Fuel"],
    medical:["Stress","Anxiety","Pain","Insomnia"],
    desc:"The genetic backbone of modern American cannabis. OG Kush combines a sharp lemon-fuel aroma with a euphoric head rush that settles into deep body relaxation. Its exact parentage has been argued for thirty years, but its legacy is undisputed — nearly every premium California strain bred since 2000 traces back to it somewhere." },

  { id:"hindu-kush", name:"Hindu Kush", aka:"HK", type:"indica",
    parents:["Hindu Kush Mountains Landrace"], grandparents:{"Hindu Kush Mountains Landrace":["Landrace"]},
    thc:"15-20%", cbd:"<2%", flowering:"45-50 days",
    breeder:"Landrace", origin:"Afghanistan / Pakistan border",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Earthy","Hash","Pine","Sweet"],
    medical:["Insomnia","Pain","Stress","Anxiety"],
    desc:"A pure indica landrace from the rugged mountain ranges that gave Kush its name. Hindu Kush has been used for centuries to produce hashish, and its hardy, fast-flowering structure made it the foundation for countless Western breeding programs — from Northern Lights to OG Kush itself." },

  { id:"bubba-kush", name:"Bubba Kush", aka:"BK, Bubba", type:"indica",
    parents:["OG Kush","Northern Lights"],
    grandparents:{"OG Kush":["Chemdawg","Hindu Kush"],"Northern Lights":["Afghani","Thai"]},
    thc:"15-22%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Matt 'Bubba' Berger (attributed)", origin:"New Orleans / Los Angeles — 1996",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Coffee","Hash","Sweet","Earthy"],
    medical:["Insomnia","Pain","Stress","Muscle Spasms"],
    desc:"One of the most recognizable indicas in the world, with a rich coffee-and-chocolate aroma and a deeply sedating body effect. Bubba Kush emerged in mid-90s Los Angeles and has stayed a staple of the indica lineup ever since, spawning Pre-98 Bubba, Master Kush phenos, and countless hash-making cuts." },

  { id:"master-kush", name:"Master Kush", type:"indica",
    parents:["Hindu Kush","Skunk"],
    grandparents:{"Hindu Kush":["Hindu Kush Landrace"],"Skunk":["Afghani","Acapulco Gold","Colombian Gold"]},
    thc:"18-24%", cbd:"<0.5%", flowering:"49-56 days",
    breeder:"White Label Seed Co", origin:"Netherlands — early 1990s",
    terpenes:["Myrcene","Pinene","Caryophyllene"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Earthy","Citrus","Hash","Pine"],
    medical:["Insomnia","Stress","Pain","Anxiety"],
    desc:"A two-time Cannabis Cup winner that combined two distinct Hindu Kush phenotypes with classic Skunk to produce one of Amsterdam's most popular indicas. Master Kush is dense, resinous, and rewarding to grow, with a balanced earthy-citrus aroma." },

  { id:"skywalker-og", name:"Skywalker OG", aka:"Skywalker OG Kush", type:"indica",
    parents:["Skywalker","OG Kush"],
    grandparents:{"Skywalker":["Mazar","Blueberry"],"OG Kush":["Chemdawg","Hindu Kush"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Reserva Privada (commercial)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Pine","Citrus","Diesel","Spicy"],
    medical:["Pain","Insomnia","Stress","Appetite Loss"],
    desc:"Skywalker OG combines the heavy, stoning body presence of Skywalker with the sharp citrus-fuel signature of OG Kush. The result hits like a true 'force' — strong enough that even seasoned smokers respect it. A go-to evening strain for serious pain or sleep issues." },

  { id:"chemdawg", name:"Chemdawg", aka:"Chemdog, Chem Dog", type:"hybrid",
    parents:["Unknown Thai","Unknown Nepalese"],
    grandparents:{"Unknown Thai":["Landrace"],"Unknown Nepalese":["Landrace"]},
    thc:"15-20%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Unknown ('Chemdog' attributed)", origin:"USA — early 1990s",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Euphoric","Relaxed","Happy","Creative"],
    flavors:["Diesel","Chemical","Earthy","Pungent"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"The legendary mystery seed. Chemdawg's origin story — seeds purchased from a bag at a Grateful Dead concert in the early 90s — has been told a thousand ways and proven none. What's not in dispute is its impact: Chemdawg is the parent of Sour Diesel and OG Kush, making it one of the most influential strains of the modern era." },

  { id:"chems-sister", name:"Chem's Sister", aka:"Chem Sis", type:"hybrid",
    parents:["Chemdawg"], grandparents:{"Chemdawg":["Unknown Thai","Unknown Nepalese"]},
    thc:"19-24%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Unknown", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Euphoric","Uplifted","Happy","Creative"],
    flavors:["Diesel","Pine","Earthy","Sour"],
    medical:["Stress","Depression","Anxiety","Fatigue"],
    desc:"A rare female phenotype pulled from Chemdawg seed stock that became influential in its own right. Chem's Sister is one of the parents of Gorilla Glue #4, contributing its sharp diesel notes and energetic head buzz." },

  { id:"larry-og", name:"Larry OG", aka:"Lemon Larry, Lemon Larry OG", type:"hybrid",
    parents:["OG Kush","SFV OG"],
    grandparents:{"OG Kush":["Chemdawg","Hindu Kush"],"SFV OG":["OG Kush Phenotype"]},
    thc:"19-22%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cali Connection (commercial line)", origin:"Orange County, CA",
    terpenes:["Limonene","Myrcene","Caryophyllene"],
    effects:["Relaxed","Happy","Uplifted","Euphoric"],
    flavors:["Lemon","Pine","Earthy","Citrus"],
    medical:["Stress","Pain","Anxiety","Insomnia"],
    desc:"A bright, lemon-forward OG cut from Orange County that became one of the most coveted clone-only strains of the late 2000s. Larry OG hits clean, with a citrus terpene profile that lifts the heavy OG Kush base into something more daytime-friendly. Foundational parent in modern OG breeding — Purple Punch, Larry OG BX1/2/3, and many Aficionado releases all trace through it." },

  { id:"face-off-og", name:"Face Off OG", type:"indica",
    parents:["OG Kush phenotype"], grandparents:{"OG Kush phenotype":["Chemdawg","Hindu Kush"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Archive Seed Bank (commercial)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Fuel","Earthy","Pine","Spicy"],
    medical:["Pain","Insomnia","Stress","Muscle Spasms"],
    desc:"A heavy-hitting OG cut that Archive Seed Bank used to anchor an entire breeding line, most famously Do-Si-Dos. Face Off OG runs gassy and dense, with effects that lean strongly toward couch-lock." },

  { id:"sfv-og", name:"SFV OG", aka:"San Fernando Valley OG, SFV OG Kush", type:"hybrid",
    parents:["OG Kush phenotype"], grandparents:{"OG Kush phenotype":["Chemdawg","Hindu Kush"]},
    thc:"19-22%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Cali Connection (commercial)", origin:"San Fernando Valley, CA",
    terpenes:["Limonene","Pinene","Caryophyllene"],
    effects:["Relaxed","Uplifted","Happy","Euphoric"],
    flavors:["Lemon","Pine","Earthy","Diesel"],
    medical:["Stress","Headaches","Pain","Depression"],
    desc:"A bright, energetic OG phenotype that became a defining cut of the SFV. Lighter on the body than Triangle Kush but with the same lemon-fuel signature, SFV OG is widely used in modern hybrid breeding and is a foundational parent in Fire OG, Larry OG, and many other heritage California OG hybrids." },

  { id:"gsc", name:"Girl Scout Cookies", aka:"GSC, Forum Cut, Thin Mint", type:"hybrid",
    parents:["OG Kush","Durban Poison"],
    grandparents:{"OG Kush":["Chemdawg","Hindu Kush"],"Durban Poison":["South African Landrace"]},
    thc:"19-28%", cbd:"<0.2%", flowering:"63-70 days",
    breeder:"Cookie Fam (Berner)", origin:"San Francisco Bay Area — 2012",
    terpenes:["Caryophyllene","Limonene","Humulene"],
    effects:["Happy","Euphoric","Relaxed","Creative"],
    flavors:["Sweet","Mint","Earthy","Cookie"],
    medical:["Pain","Stress","Appetite Loss","Nausea"],
    desc:"The strain that defined an era. Girl Scout Cookies emerged from the Bay Area in 2011 and reshaped the entire premium flower market within two years, spawning a family that includes Gelato, Sunset Sherbet, Wedding Cake, and dozens of others. Sweet, minty, and powerful." },

  { id:"animal-cookies", name:"Animal Cookies", aka:"Animal Crackers", type:"hybrid",
    parents:["Girl Scout Cookies","Fire OG"],
    grandparents:{"Girl Scout Cookies":["OG Kush","Durban Poison"],"Fire OG":["OG Kush","SFV OG"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"BC Bud Depot", origin:"Canada / USA",
    terpenes:["Caryophyllene","Limonene","Humulene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Sweet","Cookie","Sour","Vanilla"],
    medical:["Pain","Insomnia","Stress","Appetite Loss"],
    desc:"A heavier, gassier cookie cut that became a breeding workhorse in the late 2010s. Animal Cookies brings the cookie sweetness with much more OG punch underneath, making it ideal for dense, resinous, sleep-friendly hybrids." },

  { id:"sunset-sherbet", name:"Sunset Sherbet", aka:"Sherbet, Sherb", type:"hybrid",
    parents:["Girl Scout Cookies","Pink Panties"],
    grandparents:{"Girl Scout Cookies":["OG Kush","Durban Poison"],"Pink Panties":["Burmese Kush","Florida Kush"]},
    thc:"15-19%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Mr. Sherbinski", origin:"San Francisco Bay Area — 2013",
    terpenes:["Caryophyllene","Myrcene","Humulene"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Sweet","Berry","Citrus","Candy"],
    medical:["Stress","Tension","Mood","Fatigue"],
    desc:"The strain Sherbinski built his reputation on. Sunset Sherbet softened GSC's potency with a fruity, candy-sweet aromatic profile that became the bridge to Gelato when crossed with Thin Mint GSC. A foundational dessert-strain parent." },

  { id:"gelato", name:"Gelato", aka:"Larry Bird, Gelato #42", type:"hybrid",
    parents:["Sunset Sherbet","Thin Mint GSC"],
    grandparents:{"Sunset Sherbet":["GSC","Pink Panties"],"Thin Mint GSC":["OG Kush Breath","F1 Durb"]},
    thc:"20-25%", cbd:"<0.2%", flowering:"56-63 days",
    breeder:"Cookie Fam / Sherbinski", origin:"San Francisco Bay Area — 2014",
    terpenes:["Limonene","Myrcene","Caryophyllene"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Sweet","Citrus","Fruit","Berry"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"The strain that redefined dessert genetics. Gelato presents in numerous numbered phenotypes (#33, #41, #42 are the most prized), each bringing its own fruit and creme variation. Vibrant trichome production and balanced effects made Gelato the parent of the modern era." },

  { id:"runtz", name:"Runtz", aka:"Runtz OG", type:"hybrid",
    parents:["Zkittlez","Gelato"],
    grandparents:{"Zkittlez":["Grape Ape","Grapefruit"],"Gelato":["Sunset Sherbet","Thin Mint GSC"]},
    thc:"19-29%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cookies (Yung LB)", origin:"Los Angeles, CA — 2017",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Euphoric","Happy","Relaxed","Tingly"],
    flavors:["Sweet","Candy","Tropical","Fruit"],
    medical:["Stress","Anxiety","Insomnia","Pain"],
    desc:"The candy-coated phenomenon. Runtz hit the scene in 2017 and went mainstream within two years, becoming the 2020 Leafly Strain of the Year. Its fruity, candy-store aroma and slow-building euphoric effects spawned an entire family — White Runtz, Pink Runtz, Rainbow Runtz, and beyond." },

  { id:"white-runtz", name:"White Runtz", type:"hybrid",
    parents:["Zkittlez","Gelato"],
    grandparents:{"Zkittlez":["Grape Ape","Grapefruit"],"Gelato":["Sunset Sherbet","Thin Mint GSC"]},
    thc:"23-29%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cookies", origin:"Los Angeles, CA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Euphoric","Relaxed","Happy","Tingly"],
    flavors:["Sweet","Candy","Berry","Vanilla"],
    medical:["Stress","Anxiety","Pain","Insomnia"],
    desc:"A frostier phenotype of Runtz with a slightly more vanilla-forward terpene profile. White Runtz's intense trichome production made it a favorite for boutique flower and concentrate alike." },

  { id:"zkittlez", name:"Zkittlez", aka:"Skittlez, Island Mix", type:"indica",
    parents:["Grape Ape","Grapefruit"],
    grandparents:{"Grape Ape":["Mendo Purp","Skunk","Afghani"],"Grapefruit":["Cinderella 99","Unknown Indica"]},
    thc:"15-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"3rd Gen Family & Terp Hogz", origin:"Humboldt County, CA — 2012",
    terpenes:["Caryophyllene","Humulene","Linalool"],
    effects:["Happy","Relaxed","Uplifted","Euphoric"],
    flavors:["Grape","Tropical","Sweet","Berry"],
    medical:["Stress","Anxiety","Pain","Insomnia"],
    desc:"A tropical fruit explosion in flower form. Zkittlez stacked Cannabis Cup wins through the late 2010s on the strength of its mouth-coating sweetness and its uniquely manageable indica effects — relaxing without putting you out." },

  { id:"do-si-dos", name:"Do-Si-Dos", aka:"Dosidos, Dosi", type:"indica",
    parents:["Girl Scout Cookies","Face Off OG"],
    grandparents:{"Girl Scout Cookies":["OG Kush","Durban Poison"],"Face Off OG":["OG Kush phenotype"]},
    thc:"21-30%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Archive Seed Bank", origin:"Oregon — 2014",
    terpenes:["Limonene","Caryophyllene","Linalool"],
    effects:["Relaxed","Euphoric","Happy","Sleepy"],
    flavors:["Sweet","Earthy","Floral","Mint"],
    medical:["Pain","Insomnia","Anxiety","Stress"],
    desc:"Archive Seed Bank's flagship indica and a foundational parent in the modern era. Do-Si-Dos brings GSC's cookie sweetness together with Face Off OG's heavy gas, producing a complex floral-mint profile and one of the most reliably potent indica experiences available." },

  { id:"mac", name:"MAC", aka:"Miracle Alien Cookies", type:"hybrid",
    parents:["Alien Cookies","Columbian × Starfighter"],
    grandparents:{"Alien Cookies":["GSC","Alien Dawg"],"Columbian × Starfighter":["Colombian Landrace","Starfighter"]},
    thc:"20-23%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Capulator", origin:"USA — 2016",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Floral","Citrus","Cream","Earthy"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"Capulator's masterwork. Miracle Alien Cookies brings together a complex three-way cross to produce a smooth, creamy floral-citrus aroma and a balanced euphoric high. The pale green buds covered in white trichomes earned MAC permanent boutique status." },

  { id:"ice-cream-cake", name:"Ice Cream Cake", aka:"ICC", type:"indica",
    parents:["Wedding Cake","Gelato #33"],
    grandparents:{"Wedding Cake":["Triangle Kush","Animal Mints"],"Gelato #33":["Sunset Sherbet","Thin Mint GSC"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Seed Junky Genetics", origin:"USA — 2018",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Vanilla","Sweet","Cream","Dough"],
    medical:["Insomnia","Anxiety","Stress","Pain"],
    desc:"A decadent dessert indica with a smell like sweetened condensed milk. Ice Cream Cake sedates more than it spaces — a genuine evening strain that pairs creamy vanilla flavor with deep body relaxation." },

  { id:"mimosa", name:"Mimosa", aka:"Purple Mimosa", type:"hybrid",
    parents:["Clementine","Purple Punch"],
    grandparents:{"Clementine":["Tangie","Lemon Skunk"],"Purple Punch":["Larry OG","Granddaddy Purple"]},
    thc:"19-27%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Symbiotic Genetics", origin:"California — 2017",
    terpenes:["Terpinolene","Caryophyllene","Myrcene"],
    effects:["Happy","Uplifted","Energetic","Focused"],
    flavors:["Citrus","Orange","Sweet","Fruit"],
    medical:["Depression","Fatigue","Stress","Anxiety"],
    desc:"A sativa-dominant cocktail strain that smells like a brunch glass. Mimosa rides on a sharp citrus terpinolene profile with subtle berry undertones, delivering a clean, productive head high without the racing edge of pure sativas." },

  { id:"clementine", name:"Clementine", type:"sativa",
    parents:["Tangie","Lemon Skunk"],
    grandparents:{"Tangie":["California Orange","Skunk Hybrid"],"Lemon Skunk":["Skunk #1 phenotype","Unknown"]},
    thc:"19-27%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Crockett Family Farms", origin:"California",
    terpenes:["Terpinolene","Limonene","Myrcene"],
    effects:["Happy","Energetic","Uplifted","Focused"],
    flavors:["Orange","Citrus","Sweet","Skunk"],
    medical:["Depression","Stress","Fatigue","Headaches"],
    desc:"One of the brightest citrus strains in modern breeding. Clementine combines Tangie's intense orange aroma with Lemon Skunk's energetic high, producing a strain that smells like fresh-peeled fruit and lifts the mood from the first hit." },

  { id:"haze", name:"Haze", aka:"Original Haze", type:"sativa",
    parents:["Colombian Gold","Mexican","Thai","South Indian"],
    grandparents:{"Colombian Gold":["Landrace"],"Mexican":["Landrace"],"Thai":["Landrace"],"South Indian":["Landrace"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"84-91 days",
    breeder:"Haze Brothers", origin:"Santa Cruz, CA — 1960s-70s",
    terpenes:["Terpinolene","Myrcene","Caryophyllene"],
    effects:["Energetic","Uplifted","Creative","Euphoric"],
    flavors:["Earthy","Spicy","Citrus","Incense"],
    medical:["Depression","Fatigue","Stress","ADHD"],
    desc:"The matriarch of all modern sativas. Original Haze was developed in 1960s Santa Cruz by combining four world-class landrace sativas, then exported to the Netherlands where it became the foundation of Sensi Seeds, Green House, and dozens of other Dutch breeding programs." },

  { id:"super-silver-haze", name:"Super Silver Haze", aka:"SSH", type:"sativa",
    parents:["Skunk","Northern Lights","Haze"],
    grandparents:{"Skunk":["Afghani","Acapulco Gold","Colombian Gold"],"Northern Lights":["Afghani","Thai"],"Haze":["Colombian","Mexican","Thai","South Indian"]},
    thc:"18-23%", cbd:"<0.1%", flowering:"63-77 days",
    breeder:"Green House Seeds", origin:"Netherlands — 1990s",
    terpenes:["Terpinolene","Caryophyllene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Citrus","Skunk","Spicy","Earthy"],
    medical:["Depression","Fatigue","Stress","Pain"],
    desc:"A three-time Cannabis Cup winner that became the gold standard for commercial Haze. Super Silver Haze tames Original Haze's unmanageable flowering time with Northern Lights and Skunk indica genetics, producing a frosty, citrus-skunk Haze that finishes in the standard window." },

  { id:"amnesia-haze", name:"Amnesia Haze", aka:"AH", type:"sativa",
    parents:["Haze","Jamaican","Laos","Hawaiian","Afghani"],
    grandparents:{"Haze":["Colombian","Mexican","Thai","South Indian"],"Jamaican":["Landrace"],"Laos":["Landrace"]},
    thc:"20-25%", cbd:"<1%", flowering:"70-84 days",
    breeder:"Soma Seeds / Hy-Pro", origin:"Netherlands — 1990s",
    terpenes:["Terpinolene","Myrcene","Caryophyllene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Earthy","Citrus","Lemon","Sweet"],
    medical:["Fatigue","Depression","Stress","PTSD"],
    desc:"A coffeeshop classic from the Soma Seeds catalog. Amnesia Haze packs a complex global lineage — Jamaican, Laotian, Hawaiian, and Afghani all contribute — into one of the most powerful Haze experiences available." },

  { id:"jack-herer", name:"Jack Herer", aka:"JH, The Jack", type:"sativa",
    parents:["Haze","Northern Lights #5","Shiva Skunk"],
    grandparents:{"Haze":["Colombian","Mexican","Thai","South Indian"],"Northern Lights #5":["Afghani","Thai"],"Shiva Skunk":["Northern Lights #5","Skunk #1"]},
    thc:"18-24%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Sensi Seeds", origin:"Netherlands — 1994",
    terpenes:["Terpinolene","Caryophyllene","Ocimene"],
    effects:["Happy","Energetic","Creative","Euphoric"],
    flavors:["Pine","Earthy","Wood","Spicy"],
    medical:["Fatigue","Stress","Depression","Pain"],
    desc:"Named for the cannabis activist and author of 'The Emperor Wears No Clothes', Jack Herer combines Haze's cerebral lift with the dense flowering structure of two Sensi indica lines. A multiple Cup winner that has been relicensed across the world and remains a benchmark sativa-leaning hybrid." },

  { id:"lemon-haze", name:"Lemon Haze", aka:"LH", type:"sativa",
    parents:["Lemon Skunk","Silver Haze"],
    grandparents:{"Lemon Skunk":["Skunk #1 phenotype","Unknown Lemon Skunk"],"Silver Haze":["Haze","Northern Lights #5","Skunk #1"]},
    thc:"17-25%", cbd:"<0.2%", flowering:"63-70 days",
    breeder:"Green House Seeds", origin:"Netherlands — 2000s",
    terpenes:["Terpinolene","Ocimene","Myrcene"],
    effects:["Happy","Energetic","Uplifted","Creative"],
    flavors:["Lemon","Citrus","Sweet","Earthy"],
    medical:["Fatigue","Depression","Stress","Pain"],
    desc:"A bright, lemon-forward Haze with the energetic profile of its parents and a sharp citrus aroma that makes it instantly recognizable." },

  { id:"nyc-diesel", name:"NYC Diesel", aka:"New York City Diesel", type:"sativa",
    parents:["Mexican","Afghani"],
    grandparents:{"Mexican":["Landrace"],"Afghani":["Landrace"]},
    thc:"19-21%", cbd:"<0.1%", flowering:"77-84 days",
    breeder:"Soma Seeds", origin:"NYC / Netherlands — 1990s",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Uplifted","Creative","Relaxed"],
    flavors:["Diesel","Citrus","Grapefruit","Sweet"],
    medical:["Stress","Depression","Pain","Fatigue"],
    desc:"A grapefruit-and-diesel sativa that captured the spirit of New York hip-hop culture in the early 2000s. NYC Diesel blends Mexican and Afghani in a way that produces an unusual citrus-fuel aromatic combination found nowhere else." },

  { id:"strawberry-diesel", name:"Strawberry Diesel", type:"hybrid",
    parents:["Strawberry Cough","Sour Diesel"],
    grandparents:{"Strawberry Cough":["Strawberry Fields","Haze"],"Sour Diesel":["Chemdawg 91","Super Skunk"]},
    thc:"18-25%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Various", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Happy","Uplifted","Relaxed","Creative"],
    flavors:["Strawberry","Diesel","Sweet","Earthy"],
    medical:["Stress","Depression","Pain","Anxiety"],
    desc:"A sweet strawberry inhale meets a sharp diesel exhale. Strawberry Diesel parented Bruce Banner #3 and shows up in numerous high-THC modern crosses." },

  { id:"strawberry-cough", name:"Strawberry Cough", aka:"SC", type:"sativa",
    parents:["Strawberry Fields","Haze"],
    grandparents:{"Strawberry Fields":["Unknown"],"Haze":["Colombian","Mexican","Thai","South Indian"]},
    thc:"15-20%", cbd:"<0.4%", flowering:"70-77 days",
    breeder:"Kyle Kushman", origin:"USA — 2000s",
    terpenes:["Myrcene","Caryophyllene","Ocimene"],
    effects:["Happy","Uplifted","Energetic","Creative"],
    flavors:["Strawberry","Sweet","Berry","Earthy"],
    medical:["Stress","Anxiety","Depression","PTSD"],
    desc:"Kyle Kushman's signature strain. Strawberry Cough delivers a distinct sweet-berry aroma with Haze's clear-headed cerebral lift, plus the characteristic expansion that gives the strain its name." },

  { id:"headband", name:"Headband", aka:"Sour OG", type:"hybrid",
    parents:["OG Kush","Sour Diesel"],
    grandparents:{"OG Kush":["Chemdawg","Hindu Kush"],"Sour Diesel":["Chemdawg 91","Super Skunk"]},
    thc:"19-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Reserva Privada (commercial)", origin:"Northern California — 2000s",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Diesel","Citrus","Earthy","Pine"],
    medical:["Pain","Stress","Headaches","Migraines"],
    desc:"Named for the slight pressure-around-the-temples feeling it produces, Headband combines two of the most influential American strains into a balanced hybrid that runs gassy and resinous." },

  { id:"uk-cheese", name:"UK Cheese", aka:"Cheese, Exodus Cheese", type:"hybrid",
    parents:["Skunk #1 phenotype"], grandparents:{"Skunk #1 phenotype":["Afghani","Acapulco Gold","Colombian Gold"]},
    thc:"15-20%", cbd:"<0.2%", flowering:"56-63 days",
    breeder:"Exodus Collective", origin:"United Kingdom — 1980s-90s",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Hungry"],
    flavors:["Cheese","Pungent","Earthy","Skunk"],
    medical:["Stress","Pain","Depression","Appetite Loss"],
    desc:"A pungent Skunk phenotype that emerged from the Exodus Collective in 1980s Britain and became the foundation of the entire 'Cheese' lineage." },

  { id:"blue-cheese", name:"Blue Cheese", type:"indica",
    parents:["UK Cheese","Blueberry"],
    grandparents:{"UK Cheese":["Skunk #1 phenotype"],"Blueberry":["Afghani","Thai","Purple Thai"]},
    thc:"15-20%", cbd:"<0.2%", flowering:"56-63 days",
    breeder:"Big Buddha Seeds", origin:"United Kingdom — 2000s",
    terpenes:["Myrcene","Caryophyllene","Linalool"],
    effects:["Relaxed","Happy","Sleepy","Hungry"],
    flavors:["Cheese","Berry","Sweet","Earthy"],
    medical:["Pain","Insomnia","Stress","Appetite Loss"],
    desc:"A sweet-and-funky combination that pairs the sharp dairy notes of UK Cheese with DJ Short's iconic Blueberry." },

  { id:"granddaddy-purple", name:"Granddaddy Purple", aka:"GDP", type:"indica",
    parents:["Purple Urkle","Big Bud"],
    grandparents:{"Purple Urkle":["Mendo Purp"],"Big Bud":["Afghani","Skunk #1","Northern Lights"]},
    thc:"17-23%", cbd:"<0.1%", flowering:"56-70 days",
    breeder:"Ken Estes", origin:"San Francisco, CA — 2003",
    terpenes:["Myrcene","Caryophyllene","Ocimene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Grape","Berry","Sweet","Earthy"],
    medical:["Pain","Insomnia","Muscle Spasms","Appetite Loss"],
    desc:"Ken Estes' contribution to California cannabis royalty. Granddaddy Purple's grape-berry aroma, oversized purple buds, and full-body sedation made it an instant classic when it hit the Bay Area scene in 2003." },

  { id:"purple-urkle", name:"Purple Urkle", type:"indica",
    parents:["Mendo Purp phenotype"], grandparents:{"Mendo Purp phenotype":["Unknown"]},
    thc:"18-21%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Unknown (NorCal)", origin:"Northern California — 1980s",
    terpenes:["Myrcene","Caryophyllene","Linalool"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Grape","Berry","Earthy","Skunk"],
    medical:["Insomnia","Pain","Stress","Anxiety"],
    desc:"A NorCal classic with murky origins and clear results — deep purple flowers, a grape-and-skunk terpene profile, and a heavy, dreamy indica effect. Purple Urkle parented Granddaddy Purple, sealing its place in California genetic history." },

  { id:"purple-punch", name:"Purple Punch", aka:"PP", type:"indica",
    parents:["Larry OG","Granddaddy Purple"],
    grandparents:{"Larry OG":["OG Kush","SFV OG"],"Granddaddy Purple":["Purple Urkle","Big Bud"]},
    thc:"19-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Supernova Gardens", origin:"USA — 2017",
    terpenes:["Caryophyllene","Limonene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Grape","Berry","Vanilla","Sweet"],
    medical:["Insomnia","Pain","Stress","Nausea"],
    desc:"A heavy-hitter dessert indica with grape-Kool-Aid sweetness on the front and lavender-vanilla on the finish. Purple Punch became a rapid hit in the late 2010s and shows up as a parent in dozens of modern hybrids including Wedding Crasher and Mimosa." },

  { id:"mendo-purp", name:"Mendo Purp", aka:"Mendocino Purps, Mendo Purple, Purps, Purp", type:"indica",
    parents:["Unknown"], grandparents:{},
    thc:"15-20%", cbd:"<0.2%", flowering:"49-56 days",
    breeder:"Unknown", origin:"Mendocino County, CA — 1980s",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Happy","Sleepy","Creative"],
    flavors:["Grape","Pine","Berry","Sweet"],
    medical:["Stress","Pain","Insomnia","Appetite Loss"],
    desc:"A Northern California institution. Mendocino Purps emerged from the legacy growers of Mendocino County and became the foundation of countless modern purple strains, including Granddaddy Purple, Grape Ape, and Zkittlez through Grape Ape. If the color purple had a smell it would be the smell of Mendo Purp." },

  { id:"afghani", name:"Afghani", aka:"Afghani #1", type:"indica",
    parents:["Hindu Kush Mountains Landrace"], grandparents:{"Hindu Kush Mountains Landrace":["Landrace"]},
    thc:"15-20%", cbd:"<6%", flowering:"49-56 days",
    breeder:"Landrace", origin:"Afghanistan",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Earthy","Hash","Pine","Sweet"],
    medical:["Insomnia","Pain","Stress","Appetite Loss"],
    desc:"A pure indica landrace from Afghanistan — short, hardy, resin-heavy plants bred over generations for hashish production. Afghani is the genetic root of nearly every modern indica." },

  { id:"thai", name:"Thai", aka:"Thai Stick, Thai Sativa", type:"sativa",
    parents:["Thai Landrace"], grandparents:{"Thai Landrace":["Landrace"]},
    thc:"12-18%", cbd:"<0.5%", flowering:"84-105 days",
    breeder:"Landrace", origin:"Thailand",
    terpenes:["Terpinolene","Limonene","Myrcene"],
    effects:["Energetic","Euphoric","Creative","Happy"],
    flavors:["Citrus","Earthy","Wood","Spicy"],
    medical:["Fatigue","Depression","Stress"],
    desc:"A pure sativa landrace from Thailand that became internationally famous in the 1970s through 'Thai Stick' — buds tied to bamboo skewers." },

  { id:"durban-poison", name:"Durban Poison", aka:"DP", type:"sativa",
    parents:["South African Landrace"], grandparents:{"South African Landrace":["Landrace"]},
    thc:"17-20%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Landrace (Ed Rosenthal)", origin:"Durban, South Africa",
    terpenes:["Terpinolene","Myrcene","Ocimene"],
    effects:["Energetic","Uplifted","Happy","Focused"],
    flavors:["Sweet","Earthy","Pine","Anise"],
    medical:["Fatigue","Depression","Stress","ADHD"],
    desc:"A pure sativa from the Durban port region of South Africa, brought to the United States by cannabis activist Ed Rosenthal in the 1970s." },

  { id:"colombian-gold", name:"Colombian Gold", aka:"Santa Marta Gold", type:"sativa",
    parents:["Colombian Landrace"], grandparents:{"Colombian Landrace":["Landrace"]},
    thc:"15-19%", cbd:"<0.5%", flowering:"77-91 days",
    breeder:"Landrace", origin:"Santa Marta, Colombia",
    terpenes:["Terpinolene","Myrcene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Earthy","Sweet","Lemon","Skunk"],
    medical:["Stress","Depression","Fatigue"],
    desc:"The legendary 1970s import that flooded American markets and shaped a generation's experience of cannabis. Colombian Gold is a parent of Original Haze and Skunk #1." },

  { id:"acapulco-gold", name:"Acapulco Gold", aka:"AG", type:"sativa",
    parents:["Mexican Landrace"], grandparents:{"Mexican Landrace":["Landrace"]},
    thc:"15-23%", cbd:"<0.1%", flowering:"70-84 days",
    breeder:"Landrace", origin:"Acapulco, Mexico",
    terpenes:["Pinene","Myrcene","Caryophyllene"],
    effects:["Energetic","Euphoric","Happy","Creative"],
    flavors:["Sweet","Earthy","Pine","Coffee"],
    medical:["Fatigue","Stress","Depression","Pain"],
    desc:"A legendary Mexican sativa landrace from the Acapulco region, prized in the 1960s and 70s for its distinctive gold-colored buds and powerful clear-headed high." }

]);
/* ── BATCH 1 (continued) ─────────────────────────────────────── */
window.LSS_REFERENCE = window.LSS_REFERENCE.concat([

  { id:"panama-red", name:"Panama Red", type:"sativa",
    parents:["Panamanian Landrace"], grandparents:{"Panamanian Landrace":["Landrace"]},
    thc:"15-19%", cbd:"<0.5%", flowering:"77-91 days",
    breeder:"Landrace", origin:"Panama",
    terpenes:["Terpinolene","Pinene","Myrcene"],
    effects:["Energetic","Euphoric","Happy","Creative"],
    flavors:["Earthy","Sweet","Wood","Spicy"],
    medical:["Fatigue","Depression","Stress"],
    desc:"A 1960s American underground favorite. Panama Red's reddish hairs and energetic effect made it iconic in counterculture history, and traces of it persist in some heritage sativa lines." },

  { id:"durban", name:"Durban (landrace)", type:"sativa",
    parents:["South African Landrace"], grandparents:{"South African Landrace":["Landrace"]},
    thc:"15-19%", cbd:"<0.3%", flowering:"56-70 days",
    breeder:"Landrace", origin:"Durban region, South Africa",
    terpenes:["Terpinolene","Pinene","Myrcene"],
    effects:["Energetic","Uplifted","Focused","Happy"],
    flavors:["Anise","Sweet","Pine","Spicy"],
    medical:["Fatigue","Depression","Stress","ADHD"],
    desc:"Distinct from the popularized 'Durban Poison' commercial cut, the original Durban landrace populations show wider phenotypic variation — taller, faster-flowering, and frequently with the same anise-licorice aromatic signature." },

  { id:"malawi", name:"Malawi", aka:"Malawi Gold", type:"sativa",
    parents:["Malawian Landrace"], grandparents:{"Malawian Landrace":["Landrace"]},
    thc:"16-22%", cbd:"<0.5%", flowering:"91-119 days",
    breeder:"Landrace", origin:"Malawi, southern Africa",
    terpenes:["Terpinolene","Limonene","Pinene"],
    effects:["Energetic","Uplifted","Euphoric","Creative"],
    flavors:["Sweet","Citrus","Wood","Earth"],
    medical:["Fatigue","Depression","Stress"],
    desc:"A pure equatorial sativa from Malawi famous in the 1970s as 'Malawi Gold' — long, spear-shaped buds packed into traditional cobs. The flowering time is brutal (3-4 months), but the resulting high is one of the most pure and energetic sativa experiences available." },

  { id:"lambsbread", name:"Lambsbread", aka:"Lambs Bread, Jamaican Lambsbread", type:"sativa",
    parents:["Jamaican Landrace"], grandparents:{"Jamaican Landrace":["Landrace"]},
    thc:"16-21%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Landrace", origin:"Jamaica",
    terpenes:["Terpinolene","Pinene","Myrcene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Earthy","Sweet","Wood","Pine"],
    medical:["Depression","Fatigue","Stress","ADHD"],
    desc:"A pure Jamaican landrace tied closely to Rastafarian culture and famously praised by Bob Marley. Lambsbread's bright green buds and exuberant uplifting high have given it a folkloric status that few strains can match." },

  { id:"oaxacan-gold", name:"Oaxacan Gold", type:"sativa",
    parents:["Mexican Landrace"], grandparents:{"Mexican Landrace":["Landrace"]},
    thc:"14-18%", cbd:"<0.5%", flowering:"77-84 days",
    breeder:"Landrace", origin:"Oaxaca, Mexico",
    terpenes:["Terpinolene","Pinene","Limonene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Earthy","Sweet","Wood","Citrus"],
    medical:["Fatigue","Depression","Stress"],
    desc:"A southern Mexican landrace that contributed alongside Acapulco Gold to the genetic foundation of American sativa breeding. Oaxacan Gold appears in the parentage of Purple Thai." },

  { id:"chocolate-thai", name:"Chocolate Thai", type:"sativa",
    parents:["Thai Landrace"], grandparents:{"Thai Landrace":["Landrace"]},
    thc:"10-15%", cbd:"<0.5%", flowering:"84-98 days",
    breeder:"Landrace", origin:"Thailand",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Energetic","Happy","Euphoric","Creative"],
    flavors:["Chocolate","Coffee","Earth","Wood"],
    medical:["Fatigue","Depression","Stress"],
    desc:"A 1960s-70s Thai landrace prized for its unusually low chlorophyll producing dark brown to nearly black bud color and a distinctive chocolate-coffee aroma." },

  { id:"hindu-kush-landrace", name:"Hindu Kush Landrace", type:"indica",
    parents:["Hindu Kush Mountains Landrace"], grandparents:{"Hindu Kush Mountains Landrace":["Landrace"]},
    thc:"15-20%", cbd:"<2%", flowering:"45-50 days",
    breeder:"Landrace", origin:"Hindu Kush Mountains",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Earthy","Hash","Sweet","Pine"],
    medical:["Insomnia","Pain","Stress","Anxiety"],
    desc:"The original Hindu Kush population — short, dense, fast-flowering plants from one of the harshest growing regions on earth. The genetic basis for nearly all modern indicas." },

  { id:"nepalese", name:"Nepalese (landrace)", type:"sativa",
    parents:["Nepalese Landrace"], grandparents:{"Nepalese Landrace":["Landrace"]},
    thc:"14-18%", cbd:"<0.5%", flowering:"70-84 days",
    breeder:"Landrace", origin:"Nepal",
    terpenes:["Myrcene","Pinene","Caryophyllene"],
    effects:["Happy","Euphoric","Creative","Uplifted"],
    flavors:["Earth","Wood","Spicy","Sweet"],
    medical:["Stress","Fatigue","Depression"],
    desc:"A Himalayan landrace traditionally used to make charas — hand-rubbed hashish. Nepalese genetics carry distinctive earthy-spice terpene profiles and stable mid-flowering times that have made them valuable in modern breeding." },

  { id:"lebanese", name:"Lebanese (landrace)", type:"indica",
    parents:["Lebanese Landrace"], grandparents:{"Lebanese Landrace":["Landrace"]},
    thc:"12-17%", cbd:"<2%", flowering:"49-56 days",
    breeder:"Landrace", origin:"Bekaa Valley, Lebanon",
    terpenes:["Myrcene","Pinene","Caryophyllene"],
    effects:["Relaxed","Happy","Sleepy","Hungry"],
    flavors:["Hash","Earth","Pine","Spicy"],
    medical:["Stress","Insomnia","Pain"],
    desc:"The historic genetic root of the Lebanese hash trade. Bekaa Valley landrace populations have been cultivated for hashish production for centuries." },

  { id:"gg4", name:"Gorilla Glue #4", aka:"GG4, Original Glue", type:"hybrid",
    parents:["Chem's Sister","Chocolate Diesel","Sour Dubb"],
    grandparents:{"Chem's Sister":["Chemdawg"],"Chocolate Diesel":["Sour Diesel","Chocolate Thai"],"Sour Dubb":["Sour Diesel","Sour Bubble"]},
    thc:"25-32%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"GG Strains (Joesy Whales × Lone Watty)", origin:"USA — 2013",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Euphoric","Happy","Sleepy"],
    flavors:["Pine","Earth","Sour","Chemical"],
    medical:["Pain","Insomnia","Stress","Depression"],
    desc:"The result of a happy accident in a 2013 Florida grow that ended up winning multiple Cannabis Cups. Gorilla Glue #4 produces buds so resinous they literally glue scissors during trimming, and the high lives up to the name — heavy, sticky, locking." },

  { id:"bruce-banner", name:"Bruce Banner", aka:"Bruce Banner #3", type:"hybrid",
    parents:["OG Kush","Strawberry Diesel"],
    grandparents:{"OG Kush":["Chemdawg","Hindu Kush"],"Strawberry Diesel":["Strawberry Cough","Sour Diesel"]},
    thc:"24-29%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Jason Holck (Dark Horse Genetics)", origin:"Colorado — 2009",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Euphoric","Happy","Relaxed","Creative"],
    flavors:["Earthy","Sweet","Diesel","Berry"],
    medical:["Stress","Pain","Fatigue","Depression"],
    desc:"Named after the alter ego of the Hulk, Bruce Banner #3 routinely tops THC charts and delivers the kind of fast cerebral rush that earned its naming." },

  { id:"trainwreck", name:"Trainwreck", aka:"Train Wreck", type:"hybrid",
    parents:["Mexican Sativa","Thai Sativa","Afghani Indica"],
    grandparents:{"Mexican Sativa":["Mexican Landrace"],"Thai Sativa":["Thai Landrace"],"Afghani Indica":["Afghani Landrace"]},
    thc:"18-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Unknown (Arcata, CA)", origin:"Arcata, California — 1970s",
    terpenes:["Terpinolene","Myrcene","Ocimene"],
    effects:["Euphoric","Happy","Uplifted","Creative"],
    flavors:["Pine","Lemon","Earthy","Sweet"],
    medical:["Pain","PTSD","Anxiety","ADHD"],
    desc:"A NorCal classic with a fast, hard-hitting cerebral effect that gave the strain its name." },

  { id:"ak-47", name:"AK-47", aka:"AK", type:"hybrid",
    parents:["Colombian","Mexican","Thai","Afghani"],
    grandparents:{"Colombian":["Landrace"],"Mexican":["Landrace"],"Thai":["Landrace"],"Afghani":["Landrace"]},
    thc:"20-22%", cbd:"<1.5%", flowering:"56-63 days",
    breeder:"Serious Seeds (Simon)", origin:"Netherlands — 1992",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Happy","Uplifted","Euphoric"],
    flavors:["Earthy","Floral","Sweet","Wood"],
    medical:["Stress","Pain","Depression","Fatigue"],
    desc:"Despite the aggressive name, AK-47 is one of the most well-balanced and approachable hybrids in the Serious Seeds catalog. Four landrace genetics produce a complex aromatic profile and a long-lasting mellow high." },

  { id:"northern-lights", name:"Northern Lights", aka:"NL, NL#5", type:"indica",
    parents:["Afghani","Thai"], grandparents:{"Afghani":["Landrace"],"Thai":["Landrace"]},
    thc:"16-21%", cbd:"<0.1%", flowering:"49-56 days",
    breeder:"Sensi Seeds", origin:"Seattle → Netherlands — 1985",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Sweet","Earthy","Pine","Spicy"],
    medical:["Insomnia","Pain","Stress","Appetite Loss"],
    desc:"A cornerstone of modern indica breeding. Northern Lights came out of Seattle in the early 1980s, was acquired by Sensi Seeds in the Netherlands, and proceeded to parent or grandparent half the strains in modern circulation." },

  { id:"white-widow", name:"White Widow", aka:"WW", type:"hybrid",
    parents:["Brazilian Sativa","South Indian Indica"],
    grandparents:{"Brazilian Sativa":["Landrace"],"South Indian Indica":["Landrace"]},
    thc:"18-25%", cbd:"<0.3%", flowering:"56-63 days",
    breeder:"Green House Seeds", origin:"Netherlands — 1994",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Euphoric","Uplifted","Happy","Creative"],
    flavors:["Earthy","Wood","Spicy","Herbal"],
    medical:["Stress","Depression","Pain","Fatigue"],
    desc:"The winner of the 1995 High Times Cannabis Cup and one of the most globally recognized strains ever bred." },

  { id:"skunk-1", name:"Skunk #1", aka:"Skunk", type:"hybrid",
    parents:["Afghani","Acapulco Gold","Colombian Gold"],
    grandparents:{"Afghani":["Landrace"],"Acapulco Gold":["Mexican Landrace"],"Colombian Gold":["Colombian Landrace"]},
    thc:"15-19%", cbd:"<0.3%", flowering:"56-63 days",
    breeder:"Sacred Seed Co (Sam the Skunkman)", origin:"USA → Netherlands — 1970s-80s",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Happy","Euphoric","Relaxed","Uplifted"],
    flavors:["Skunk","Earthy","Sweet","Pungent"],
    medical:["Stress","Depression","Pain","Fatigue"],
    desc:"The most genetically influential hybrid ever bred. Skunk #1 combined three powerhouse landraces into a stable, vigorous, fast-flowering plant that became the foundation of the entire Dutch seed industry." },

  { id:"blueberry", name:"Blueberry", aka:"DJ's Blueberry", type:"indica",
    parents:["Afghani","Thai","Purple Thai"],
    grandparents:{"Afghani":["Landrace"],"Thai":["Landrace"],"Purple Thai":["Oaxacan Gold","Chocolate Thai"]},
    thc:"16-24%", cbd:"<0.4%", flowering:"56-63 days",
    breeder:"DJ Short", origin:"USA — 1970s-80s",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Blueberry","Sweet","Berry","Earth"],
    medical:["Stress","Pain","Insomnia","Depression"],
    desc:"DJ Short's signature work and one of the most influential American indicas of the modern era." },

  { id:"blue-dream", name:"Blue Dream", type:"hybrid",
    parents:["Blueberry","Haze"],
    grandparents:{"Blueberry":["Afghani","Thai","Purple Thai"],"Haze":["Colombian","Mexican","Thai","South Indian"]},
    thc:"17-24%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"DJ Short × Unknown", origin:"Santa Cruz, California — early 2000s",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Creative","Happy","Uplifted"],
    flavors:["Berry","Blueberry","Sweet","Herbal"],
    medical:["Depression","Pain","Stress","Fatigue"],
    desc:"For a long stretch of the 2010s, Blue Dream was the single most-sold strain in California — a balanced, beginner-friendly hybrid that combines berry sweetness with a clean cerebral lift." },

  { id:"pineapple-express", name:"Pineapple Express", aka:"PE", type:"hybrid",
    parents:["Trainwreck","Hawaiian"],
    grandparents:{"Trainwreck":["Mexican","Thai","Afghani"],"Hawaiian":["Hawaiian Landrace"]},
    thc:"17-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"G13 Labs", origin:"USA — 2006",
    terpenes:["Caryophyllene","Ocimene","Myrcene"],
    effects:["Happy","Uplifted","Energetic","Creative"],
    flavors:["Tropical","Pineapple","Citrus","Earthy"],
    medical:["Fatigue","Stress","Depression","Pain"],
    desc:"G13 Labs introduced this strain in 2006, predating the Seth Rogen film by two years." },

  { id:"goji-og", name:"Goji OG", type:"sativa",
    parents:["Nepali OG","Snow Lotus"],
    grandparents:{"Nepali OG":["Nepalese","OG Kush"],"Snow Lotus":["Afgooey","Blockhead"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Berry","Cherry","Sweet","Wood"],
    medical:["Depression","Stress","Fatigue","Pain"],
    desc:"One of Bodhi's most celebrated releases. Goji OG combines a Nepali OG mother with the Snow Lotus father to produce a complex sweet-cherry-and-wood aromatic profile." },

  { id:"mothers-milk", name:"Mothers Milk", aka:"Mother's Milk, MM", type:"hybrid",
    parents:["Nepali OG","Appalachia"],
    grandparents:{"Nepali OG":["Nepalese","OG Kush"],"Appalachia":["Tres Dawg","Green Crack"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cream","Vanilla","Sweet","Earthy"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A creamy, dessert-like cross from Bodhi using their signature Appalachia father." },

  { id:"space-monkey", name:"Space Monkey", type:"hybrid",
    parents:["Wookie","Gorilla Glue #4"],
    grandparents:{"Wookie":["Chemdawg","Appalachia"],"Gorilla Glue #4":["Chem's Sister","Chocolate Diesel","Sour Dubb"]},
    thc:"22-28%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Euphoric","Happy","Creative"],
    flavors:["Diesel","Earth","Pine","Pungent"],
    medical:["Pain","Stress","Depression","Insomnia"],
    desc:"A potent, gas-forward Bodhi cross combining the distinctive Wookie mother with Gorilla Glue #4." },

  { id:"star-pupil", name:"Star Pupil", type:"hybrid",
    parents:["Chemdawg D","Pre-98 Bubba Kush"],
    grandparents:{"Chemdawg D":["Chemdawg"],"Pre-98 Bubba Kush":["Bubba Kush"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Diesel","Earth","Sweet","Pine"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Mass Medical workhorse that combined two of the most reliable American genetics — Chemdawg and Pre-98 Bubba Kush — into one of the more well-rounded medical hybrids in the East Coast scene." },

  { id:"blissful-wizard", name:"Blissful Wizard", type:"hybrid",
    parents:["Captain's Cake","Star Pupil"],
    grandparents:{"Captain's Cake":["Wedding Cake","Sundae Driver"],"Star Pupil":["Chemdawg D","Pre-98 Bubba Kush"]},
    thc:"22-26%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cake","Sweet","Vanilla","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A modern Mass Medical release that brings together Captain's Cake's dessert profile with the Chemdawg-and-Bubba structure of Star Pupil." },

  { id:"ecsd", name:"East Coast Sour Diesel", aka:"ECSD, Sour D", type:"sativa",
    parents:["Chemdawg 91","Super Skunk"],
    grandparents:{"Chemdawg 91":["Unknown Thai","Unknown Afghan"],"Super Skunk":["Skunk #1","Afghani"]},
    thc:"19-25%", cbd:"<0.3%", flowering:"77-84 days",
    breeder:"AJ (attributed)", origin:"East Coast USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Energetic","Euphoric","Uplifted","Creative"],
    flavors:["Diesel","Citrus","Pungent","Earth"],
    medical:["Depression","Stress","Pain","Fatigue"],
    desc:"The original East Coast cut of Sour Diesel, distinct from the West Coast Sour D phenotypes." },

  { id:"acdc", name:"ACDC", aka:"AC/DC", type:"sativa",
    parents:["Cannatonic phenotype"], grandparents:{"Cannatonic phenotype":["MK Ultra","G13 Haze"]},
    thc:"1-6%", cbd:"15-24%", flowering:"63-70 days",
    breeder:"Resin Seeds (Cannatonic origin)", origin:"USA",
    terpenes:["Myrcene","Pinene","Caryophyllene"],
    effects:["Relaxed","Focused","Calm","Clearheaded"],
    flavors:["Earth","Wood","Sweet","Pine"],
    medical:["Anxiety","Pain","Inflammation","Seizures"],
    desc:"One of the most influential high-CBD strains ever stabilized. ACDC routinely tests with CBD-to-THC ratios above 20:1." },

  { id:"charlottes-web", name:"Charlotte's Web", type:"sativa",
    parents:["Industrial Hemp","Cannabis Sativa"], grandparents:{},
    thc:"<0.3%", cbd:"15-20%", flowering:"63-70 days",
    breeder:"Stanley Brothers", origin:"Colorado — early 2010s",
    terpenes:["Pinene","Myrcene","Caryophyllene"],
    effects:["Calm","Clearheaded","Focused","Relaxed"],
    flavors:["Pine","Earth","Wood","Sweet"],
    medical:["Seizures","Inflammation","Anxiety","Pain"],
    desc:"Created by the Stanley Brothers specifically to help epileptic children, Charlotte's Web brought CBD-rich cannabis into the medical mainstream." },

  { id:"harlequin", name:"Harlequin", type:"sativa",
    parents:["Colombian Gold","Nepali","Thai","Swiss Sativa"],
    grandparents:{"Colombian Gold":["Colombian Landrace"],"Nepali":["Nepalese Landrace"],"Thai":["Thai Landrace"],"Swiss Sativa":["Landrace"]},
    thc:"4-7%", cbd:"8-16%", flowering:"56-63 days",
    breeder:"Mr. Green / House of David", origin:"USA",
    terpenes:["Myrcene","Pinene","Caryophyllene"],
    effects:["Clearheaded","Relaxed","Focused","Uplifted"],
    flavors:["Earth","Sweet","Wood","Mango"],
    medical:["Pain","Anxiety","Inflammation","PTSD"],
    desc:"A 5:2 CBD:THC sativa-dominant blend that lets the medical user retain functionality while gaining significant therapeutic benefit." },

  { id:"cannatonic", name:"Cannatonic", type:"hybrid",
    parents:["MK Ultra","G13 Haze"],
    grandparents:{"MK Ultra":["G13","OG Kush"],"G13 Haze":["G13","Hawaiian Sativa"]},
    thc:"6-12%", cbd:"6-17%", flowering:"56-63 days",
    breeder:"Resin Seeds", origin:"Spain — 2008",
    terpenes:["Myrcene","Pinene","Caryophyllene"],
    effects:["Relaxed","Calm","Focused","Uplifted"],
    flavors:["Earth","Citrus","Sweet","Wood"],
    medical:["Anxiety","Pain","Inflammation","Migraines"],
    desc:"The strain that effectively launched the high-CBD movement. Resin Seeds released Cannatonic in 2008 with a then-unheard-of 1:1 CBD:THC ratio." },

  { id:"sour-tsunami", name:"Sour Tsunami", type:"hybrid",
    parents:["Sour Diesel","NYC Diesel"],
    grandparents:{"Sour Diesel":["Chemdawg 91","Super Skunk"],"NYC Diesel":["Mexican","Afghani"]},
    thc:"6-10%", cbd:"10-13%", flowering:"63-70 days",
    breeder:"Lawrence Ringo / Southern Humboldt", origin:"California",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Calm","Focused","Relaxed","Clearheaded"],
    flavors:["Diesel","Earth","Citrus","Sweet"],
    medical:["Pain","Inflammation","Anxiety","Seizures"],
    desc:"One of the first high-CBD strains specifically bred for medical use. Lawrence Ringo developed Sour Tsunami over years of selective work." },

  { id:"lowryder", name:"Lowryder", aka:"Lowryder #1", type:"hybrid",
    parents:["Northern Lights #2","William's Wonder","Ruderalis"],
    grandparents:{"Northern Lights #2":["Afghani","Thai"],"William's Wonder":["Unknown"],"Ruderalis":["Russian Ruderalis"]},
    thc:"11-14%", cbd:"<1%", flowering:"60-70 days seed-to-harvest",
    breeder:"The Joint Doctor", origin:"Canada — 2000s",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Happy","Sleepy","Hungry"],
    flavors:["Earth","Sweet","Pine","Wood"],
    medical:["Stress","Pain","Insomnia"],
    desc:"The strain that started the entire autoflower revolution." },

  { id:"northern-lights-auto", name:"Northern Lights Auto", type:"indica",
    parents:["Northern Lights","Ruderalis"],
    grandparents:{"Northern Lights":["Afghani","Thai"],"Ruderalis":["Russian Ruderalis"]},
    thc:"15-20%", cbd:"<0.1%", flowering:"63-77 days seed-to-harvest",
    breeder:"Various", origin:"Various",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Sweet","Earth","Pine","Spicy"],
    medical:["Insomnia","Pain","Stress","Appetite Loss"],
    desc:"The autoflower version of one of cannabis history's most important indicas." },

  { id:"auto-ak-47", name:"Auto AK-47", type:"hybrid",
    parents:["AK-47","Ruderalis"],
    grandparents:{"AK-47":["Colombian","Mexican","Thai","Afghani"],"Ruderalis":["Russian Ruderalis"]},
    thc:"14-18%", cbd:"<0.5%", flowering:"63-70 days seed-to-harvest",
    breeder:"Various", origin:"Various",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Happy","Uplifted","Euphoric"],
    flavors:["Earth","Floral","Sweet","Wood"],
    medical:["Stress","Pain","Depression","Fatigue"],
    desc:"The auto version of Serious Seeds' classic AK-47, preserving its balanced four-landrace lineage in a faster, light-cycle-independent format." },

  { id:"quick-one", name:"Quick One", type:"hybrid",
    parents:["Lowryder","Old School Indica"],
    grandparents:{"Lowryder":["Northern Lights #2","William's Wonder","Ruderalis"],"Old School Indica":["Unknown"]},
    thc:"13-15%", cbd:"<1%", flowering:"56-63 days seed-to-harvest",
    breeder:"Royal Queen Seeds", origin:"Netherlands",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Happy","Hungry","Sleepy"],
    flavors:["Earth","Sweet","Pine","Wood"],
    medical:["Stress","Pain","Insomnia"],
    desc:"One of the fastest commercial autoflowers available, finishing seed-to-harvest in approximately eight weeks." },

  { id:"chocolate-diesel", name:"Chocolate Diesel", type:"sativa",
    parents:["Sour Diesel","Chocolate Thai"],
    grandparents:{"Sour Diesel":["Chemdawg 91","Super Skunk"],"Chocolate Thai":["Thai Landrace"]},
    thc:"19-22%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Unknown", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Coffee","Diesel","Earth","Chocolate"],
    medical:["Depression","Stress","Fatigue"],
    desc:"A coffee-and-fuel sativa that became one of the parents of Gorilla Glue #4." },

  { id:"grape-ape", name:"Grape Ape", type:"indica",
    parents:["Mendocino Purps","Skunk","Afghani"],
    grandparents:{"Mendocino Purps":["Unknown"],"Skunk":["Skunk #1"],"Afghani":["Landrace"]},
    thc:"15-23%", cbd:"<0.1%", flowering:"49-56 days",
    breeder:"Apothecary Genetics / Barneys Farm", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Grape","Berry","Sweet","Earth"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A grape-Kool-Aid indica that became the parent of Zkittlez." },

  { id:"grapefruit", name:"Grapefruit", type:"sativa",
    parents:["Cinderella 99","Unknown Indica"],
    grandparents:{"Cinderella 99":["Jack Herer","Shiva Skunk"],"Unknown Indica":["Unknown"]},
    thc:"15-20%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Steve of Next Generation Seeds", origin:"Canada",
    terpenes:["Limonene","Myrcene","Caryophyllene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Grapefruit","Citrus","Sweet","Tropical"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"A citrus-forward sativa that became one of the parents of Zkittlez." },

  { id:"tangie", name:"Tangie", type:"sativa",
    parents:["California Orange","Skunk Hybrid"],
    grandparents:{"California Orange":["Unknown Orange Thai","Unknown Afghan"],"Skunk Hybrid":["Skunk #1","Unknown"]},
    thc:"19-22%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"DNA Genetics", origin:"Netherlands — 2009",
    terpenes:["Terpinolene","Myrcene","Ocimene"],
    effects:["Happy","Uplifted","Euphoric","Creative"],
    flavors:["Orange","Citrus","Sweet","Tangerine"],
    medical:["Depression","Fatigue","Stress"],
    desc:"DNA Genetics' updated take on the 1990s Tangerine Dream. Tangie's overwhelming fresh-tangerine aroma made it an instant breeding classic." },

  { id:"purple-haze", name:"Purple Haze", aka:"P.Haze", type:"sativa",
    parents:["Haze","Purple Thai"],
    grandparents:{"Haze":["Colombian","Mexican","Thai","South Indian"],"Purple Thai":["Oaxacan Gold","Chocolate Thai"]},
    thc:"17-20%", cbd:"<0.1%", flowering:"70-84 days",
    breeder:"Unknown", origin:"USA — 1970s",
    terpenes:["Terpinolene","Myrcene","Ocimene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Berry","Earth","Sweet","Spicy"],
    medical:["Fatigue","Stress","Depression"],
    desc:"Immortalized in Hendrix's 1967 song, though the song predates the strain. Purple Haze exists in modern commercial form as a Haze × Purple Thai cross." },

  { id:"cherry-pie", name:"Cherry Pie", aka:"Cherry Kush", type:"hybrid",
    parents:["Granddaddy Purple","Durban Poison"],
    grandparents:{"Granddaddy Purple":["Purple Urkle","Big Bud"],"Durban Poison":["South African Landrace"]},
    thc:"16-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Unknown", origin:"San Francisco Bay Area",
    terpenes:["Caryophyllene","Limonene","Pinene"],
    effects:["Happy","Relaxed","Uplifted","Euphoric"],
    flavors:["Cherry","Sweet","Berry","Earth"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"A bright cherry-and-berry hybrid from the Bay Area that combines Granddaddy Purple's grape sweetness with Durban Poison's energetic head buzz." },

  { id:"green-crack", name:"Green Crack", aka:"Cush, Green Cush", type:"sativa",
    parents:["Skunk #1","Unknown Indica"],
    grandparents:{"Skunk #1":["Afghani","Acapulco Gold","Colombian Gold"],"Unknown Indica":["Unknown"]},
    thc:"15-25%", cbd:"<0.1%", flowering:"49-56 days",
    breeder:"Unknown (Athens, GA)", origin:"USA — 1970s-80s",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Focused"],
    flavors:["Citrus","Tropical","Sweet","Earth"],
    medical:["Fatigue","Depression","Stress","ADHD"],
    desc:"A high-energy sativa with a citrus-tropical aroma that earned its dramatic name from Snoop Dogg." },

  { id:"forbidden-fruit", name:"Forbidden Fruit", type:"indica",
    parents:["Cherry Pie","Tangie"],
    grandparents:{"Cherry Pie":["Granddaddy Purple","Durban Poison"],"Tangie":["California Orange","Skunk Hybrid"]},
    thc:"23-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Chameleon Extracts", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Cherry","Citrus","Tropical","Sweet"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A complex cherry-citrus indica that combines two iconic fruity parents." },

  { id:"sundae-driver", name:"Sundae Driver", type:"hybrid",
    parents:["Fruity Pebbles OG","Grape Pie"],
    grandparents:{"Fruity Pebbles OG":["Green Ribbon","Granddaddy Purple","Tahoe Alien"],"Grape Pie":["Cherry Pie","Grape Stomper"]},
    thc:"19-22%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cannarado Genetics", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Cream","Berry","Vanilla"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"A creamy dessert hybrid from Cannarado that became one of the defining parents of the late 2010s and 2020s." },

  { id:"apples-bananas", name:"Apples and Bananas", aka:"A&B", type:"hybrid",
    parents:["Platinum Cookies × Granddaddy Purple","Blue Power × Gelatti"],
    grandparents:{"Platinum Cookies × Granddaddy Purple":["Platinum Cookies","GDP"],"Blue Power × Gelatti":["Blue Power","Gelatti"]},
    thc:"22-30%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Compound Genetics × Cookies", origin:"USA — 2020",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Euphoric","Relaxed","Creative"],
    flavors:["Apple","Banana","Sweet","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A modern Compound Genetics × Cookies collaboration that delivers exactly what the name promises — a layered fruit aroma with apple on the inhale and banana on the exhale." },

  { id:"lemon-cherry-gelato", name:"Lemon Cherry Gelato", aka:"LCG", type:"hybrid",
    parents:["Sunset Sherbet phenotype","Girl Scout Cookies","Cherry Pie phenotype"],
    grandparents:{"Sunset Sherbet phenotype":["GSC","Pink Panties"],"Girl Scout Cookies":["OG Kush","Durban Poison"],"Cherry Pie phenotype":["GDP","Durban Poison"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Backpack Boyz", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Cherry","Lemon","Sweet","Berry"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"A modern Backpack Boyz signature with bright cherry top notes over a Gelato base." },

  { id:"motorbreath", name:"Motorbreath", aka:"Motorbreath #15", type:"hybrid",
    parents:["Chemdawg","SFV OG Kush"],
    grandparents:{"Chemdawg":["Unknown Thai","Unknown Nepalese"],"SFV OG Kush":["OG Kush phenotype"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Pisces Genetics", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Diesel","Fuel","Earth","Pine"],
    medical:["Pain","Stress","Insomnia","Depression"],
    desc:"A loud, fuel-forward hybrid that hits like the name suggests." },

  { id:"jealousy", name:"Jealousy", type:"hybrid",
    parents:["Sherbert Bx1","Gelato 41"],
    grandparents:{"Sherbert Bx1":["Sunset Sherbet"],"Gelato 41":["Sunset Sherbet","Thin Mint GSC"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Seed Junky × Minntz", origin:"USA — 2022",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Cake","Cream","Vanilla"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"The 2022 Leafly Strain of the Year." },

  { id:"london-pound-cake", name:"London Pound Cake", aka:"LPC, Pound Cake", type:"indica",
    parents:["Sunset Sherbet phenotype"], grandparents:{"Sunset Sherbet phenotype":["GSC","Pink Panties"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cookies", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Berry","Sweet","Cake","Vanilla"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"A heavy, dessert-leaning indica from the Cookies catalog with a distinctive berry-pound-cake aroma." },

  { id:"super-lemon-haze", name:"Super Lemon Haze", aka:"SLH", type:"sativa",
    parents:["Lemon Skunk","Super Silver Haze"],
    grandparents:{"Lemon Skunk":["Skunk #1 phenotype","Lemon Skunk"],"Super Silver Haze":["Skunk","Northern Lights","Haze"]},
    thc:"19-25%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Green House Seeds", origin:"Netherlands",
    terpenes:["Terpinolene","Limonene","Caryophyllene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Lemon","Citrus","Sweet","Earth"],
    medical:["Fatigue","Depression","Stress","Pain"],
    desc:"Two-time Cannabis Cup winner from Green House Seeds." },

  { id:"jack-the-ripper", name:"Jack the Ripper", aka:"JTR", type:"sativa",
    parents:["Jack's Cleaner","Space Queen"],
    grandparents:{"Jack's Cleaner":["Jack Herer phenotype"],"Space Queen":["Romulan","Cinderella 99"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"49-56 days",
    breeder:"Subcool's The Dank (TGA Genetics)", origin:"USA",
    terpenes:["Terpinolene","Limonene","Pinene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Citrus","Lemon","Pine","Mango"],
    medical:["Fatigue","Depression","Stress","Pain"],
    desc:"Subcool's terpinolene flagship." },

  { id:"cinderella-99", name:"Cinderella 99", aka:"C99, Cindy", type:"sativa",
    parents:["Jack Herer phenotype","Shiva Skunk phenotype"],
    grandparents:{"Jack Herer phenotype":["Jack Herer"],"Shiva Skunk phenotype":["Shiva Skunk"]},
    thc:"16-22%", cbd:"<0.5%", flowering:"49-56 days",
    breeder:"Brothers Grimm", origin:"USA — late 1990s",
    terpenes:["Caryophyllene","Limonene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Pineapple","Citrus","Sweet","Tropical"],
    medical:["Fatigue","Depression","Stress","Pain"],
    desc:"A Brothers Grimm classic from the late 1990s." },

  { id:"dosi-do-33", name:"Dosi-Do #33", type:"indica",
    parents:["Do-Si-Dos phenotype"], grandparents:{"Do-Si-Dos phenotype":["GSC","Face Off OG"]},
    thc:"23-28%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Archive Seed Bank", origin:"USA",
    terpenes:["Limonene","Caryophyllene","Linalool"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Mint","Floral","Sweet","Earth"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"The most-celebrated phenotype of Archive's Do-Si-Dos line." },

  { id:"oreoz", name:"Oreoz", aka:"Oreo Cookies", type:"indica",
    parents:["Cookies and Cream","Secret Weapon"],
    grandparents:{"Cookies and Cream":["GSC","Starfighter F2"],"Secret Weapon":["CheeseQuake","White Widow"]},
    thc:"23-29%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"3 Bros Grow", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Chocolate","Cookie","Sweet","Earth"],
    medical:["Pain","Insomnia","Stress","Depression"],
    desc:"A chocolate-cookie indica that exploded in popularity in the early 2020s." },

  { id:"grape-stomper", name:"Grape Stomper", aka:"Sour Grapes, Stomper", type:"sativa",
    parents:["Sour Diesel","Purple Elephant"],
    grandparents:{"Sour Diesel":["Chemdawg 91","Super Skunk"],"Purple Elephant":["Unknown"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Grape","Diesel","Sweet","Berry"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"Gage Green Group's celebrated grape-and-diesel sativa, originally circulated as 'Sour Grapes' before being released under the Grape Stomper name. Used as a parent in Mac Stomper and many other Sunken Treasure / Gage Green crosses." },

  { id:"grape-stomper-og", name:"Grape Stomper OG", aka:"GSOG", type:"hybrid",
    parents:["Grape Stomper","OG Kush"],
    grandparents:{"Grape Stomper":["Sour Diesel","Purple Elephant"],"OG Kush":["Chemdawg","Hindu Kush"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Grape","Pine","Earth","Fuel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A heavier, more indica-leaning version of Grape Stomper from Gage Green Group, anchored to OG Kush." }

]);
/* ── BATCH 1.5 — LIGHT SEEKER BREEDING PARENTS ───────────────── */
window.LSS_REFERENCE = window.LSS_REFERENCE.concat([

  { id:"heartbreaker-f1", name:"Heartbreaker F1", aka:"Heartbreaker, Kono cut, heartbreaker #4, Sweet Tarts cut, Heartbreaker Male", type:"hybrid",
    parents:["High School Sweetheart","Oz Kush"],
    grandparents:{"High School Sweetheart":["Cherry Pie Kush","Grateful Breath"],"Oz Kush":["OG Eddy Lepp","Zkittlez"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Sunken Treasure Seeds", origin:"West Coast, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Euphoric","Happy","Creative"],
    flavors:["Cherry","Sweet","Earth","Diesel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Sunken Treasure Seeds' flagship cross combining the cherry-fueled High School Sweetheart Laker cut with Oz Kush. The 'Kono' male phenotype became a workhorse stud for Light Seeker Seeds." },

  { id:"white-truffle", name:"White Truffle", aka:"Gorilla Butter, White Truffle Clone", type:"hybrid",
    parents:["GG4","Peanut Butter Breath"],
    grandparents:{"GG4":["Chem's Sister","Chocolate Diesel","Sour Dubb"],"Peanut Butter Breath":["Do-Si-Dos","Mendobreath F2"]},
    thc:"24-30%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Fresh Coast Seed Co", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Earth","Mushroom","Diesel","Pepper"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"Fresh Coast Seed Co's release of the legendary 'Gorilla Butter' line." },

  { id:"high-school-sweetheart", name:"High School Sweetheart", aka:"HSS, Laker cut, High School Sweet Heart", type:"hybrid",
    parents:["Cherry Pie Kush","Grateful Breath"],
    grandparents:{"Cherry Pie Kush":["Cherry Pie heritage","Kush"],"Grateful Breath":["OGKB","Joseph OG"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Sunken Treasure Seeds / The Real Gage Green Group", origin:"West Coast, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cherry","Earth","Sweet","Berry"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Gage Green Group creation combining the heirloom Cherry Pie Kush with Gage Green's signature Grateful Breath. The 'Laker cut' phenotype produces a distinct cherry-and-earth aromatic with deep purple-tinged flowers." },

  { id:"cake-crasher", name:"Cake Crasher", aka:"Vanilla Bourbon cut, Cake Crasher #3", type:"hybrid",
    parents:["Wedding Cake","Wedding Crasher"],
    grandparents:{"Wedding Cake":["Triangle Kush","Animal Mints"],"Wedding Crasher":["Wedding Cake","Purple Punch"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Seed Junky Genetics", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Vanilla","Cake","Sweet","Bourbon"],
    medical:["Stress","Pain","Anxiety","Insomnia"],
    desc:"A Seed Junky Genetics cross stacking Wedding Cake on top of Wedding Crasher. The Light Seeker Seeds #3 'Vanilla Bourbon' phenotype was selected for its rich bourbon-vanilla aroma." },

  { id:"mac-stomper", name:"Mac Stomper", aka:"M.A.C. Stomper", type:"hybrid",
    parents:["MAC","Grape Stomper"],
    grandparents:{"MAC":["Alien Cookies","Columbian × Starfighter"],"Grape Stomper":["Sour Diesel","Purple Elephant"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Sunken Treasure Seeds", origin:"West Coast, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Citrus","Grape","Sweet","Floral"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Sunken Treasure Seeds' celebrated release combining Capulator's MAC with Grape Stomper. Used as a father in multiple Light Seeker Seeds crosses including Lime Jelly and Elote." },

  { id:"cherry-pie-kush", name:"Cherry Pie Kush", aka:"CPK, Original CPK Heirloom", type:"hybrid",
    parents:["Cherry Pie heritage cut","Kush"],
    grandparents:{},
    thc:"20-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"The Real Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Pinene"],
    effects:["Happy","Relaxed","Uplifted","Euphoric"],
    flavors:["Cherry","Sweet","Berry","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"The Real Gage Green Group's heirloom selection combining a heritage Cherry Pie cut with classic Kush genetics." },

  { id:"grateful-breath", name:"Grateful Breath", type:"indica",
    parents:["OGKB","Joseph OG"],
    grandparents:{"OGKB":["Girl Scout Cookies"],"Joseph OG":["OG Kush"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Earth","Pine","Sweet","Coffee"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"Gage Green Group's foundational indica combining OG Kush Breath with Joseph OG." },

  { id:"oz-kush", name:"OZ Kush", aka:"Oz Kush", type:"hybrid",
    parents:["OG Eddy Lepp","Zkittlez"],
    grandparents:{"Zkittlez":["Grape Ape","Grapefruit"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Unknown", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Earth","Sweet","Tropical","Pine"],
    medical:["Stress","Pain","Anxiety","Insomnia"],
    desc:"A West Coast cross combining the heritage OG Eddy Lepp cut with Zkittlez. Used as a father in many Light Seeker Seeds crosses including Cake Breaker F1, Heart Shot F1, and Heart Stomper F1." },

  { id:"og-eddy-lepp", name:"OG Eddy Lepp", aka:"Eddy Lepp OG", type:"indica",
    parents:["OG Kush phenotype"],
    grandparents:{"OG Kush phenotype":["Chemdawg","Hindu Kush"]},
    thc:"20-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"Northern California",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Earth","Pine","Fuel","Sweet"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A heritage Northern California OG Kush phenotype named for activist and grower Eddy Lepp." },

  { id:"7d", name:"7D", aka:"Sour Cherries cut, 7D #8", type:"hybrid",
    parents:["East Coast Sour Diesel","East Coast Grateful Breath","Cherry Pie Kush"],
    grandparents:{"East Coast Sour Diesel":["Chemdawg 91","Super Skunk"],"East Coast Grateful Breath":["OGKB","Underdog OG"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Unknown", origin:"East Coast USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Energetic","Happy","Euphoric","Creative"],
    flavors:["Cherry","Diesel","Sweet","Earth"],
    medical:["Stress","Depression","Pain","Anxiety"],
    desc:"A complex East Coast three-way cross. The #8 'Sour Cherries' phenotype was used as the female parent in Light Seeker's East Coast Sweet Heart F1." },

  { id:"east-coast-grateful-breath", name:"East Coast Grateful Breath", aka:"ECGB", type:"indica",
    parents:["OGKB","Underdog OG"],
    grandparents:{"OGKB":["Girl Scout Cookies"],"Underdog OG":["OG Kush phenotype"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Earth","Coffee","Sweet","Pine"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"Gage Green Group's East Coast variant of their flagship Grateful Breath line, swapping in Underdog OG for the standard Joseph OG father." },

  { id:"underdog-og", name:"Underdog OG", type:"hybrid",
    parents:["OG Kush phenotype"],
    grandparents:{"OG Kush phenotype":["Chemdawg","Hindu Kush"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Cali Connection (commercial release)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Uplifted","Euphoric"],
    flavors:["Earth","Pine","Lemon","Fuel"],
    medical:["Stress","Pain","Anxiety","Insomnia"],
    desc:"A celebrated OG Kush phenotype that emerged from the SFV/Pacific Northwest cut-trading scene." },

  { id:"king-bling", name:"King Bling", aka:"King Bling #3", type:"hybrid",
    parents:["Platinum","King Sherb"],
    grandparents:{"Platinum":["UW Hashplant","Permafrost S1"],"King Sherb":["OGKB v2.1","Blue Sherb"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Unknown", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Sweet","Berry","Cream","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A modern boutique cross. The #3 phenotype was selected as the female parent in King of Hearts F1." },

  { id:"platinum", name:"Platinum", aka:"Platinum Cut", type:"hybrid",
    parents:["UW Hashplant","Permafrost S1"],
    grandparents:{},
    thc:"20-25%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Unknown", origin:"Pacific Northwest, USA",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Earth","Pine","Sweet","Hash"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A Pacific Northwest cross combining the legendary University of Washington Hashplant cut with a Permafrost self." },

  { id:"uw-hashplant", name:"UW Hashplant", aka:"University of Washington Hashplant", type:"indica",
    parents:["Hashplant heritage cut"],
    grandparents:{},
    thc:"18-22%", cbd:"<0.5%", flowering:"49-56 days",
    breeder:"Unknown (UW researchers, attributed)", origin:"University of Washington — 1980s",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Hash","Earth","Pine","Sweet"],
    medical:["Insomnia","Pain","Stress","Anxiety"],
    desc:"A heritage hashplant cut attributed to University of Washington research programs in the 1980s." },

  { id:"permafrost", name:"Permafrost", type:"hybrid",
    parents:["White Widow","Trinity"],
    grandparents:{"White Widow":["Brazilian Sativa","South Indian Indica"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"TGA Subcool Seeds (attributed)", origin:"Pacific Northwest, USA",
    terpenes:["Pinene","Myrcene","Caryophyllene"],
    effects:["Relaxed","Happy","Uplifted","Euphoric"],
    flavors:["Pine","Earth","Sweet","Wood"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Pacific Northwest hybrid known for its frosted appearance and balanced effect profile." },

  { id:"king-sherb", name:"King Sherb", type:"hybrid",
    parents:["OGKB v2.1","Blue Sherb"],
    grandparents:{"OGKB v2.1":["Girl Scout Cookies"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Unknown", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Berry","Sweet","Cream","Earth"],
    medical:["Stress","Pain","Anxiety","Insomnia"],
    desc:"A boutique cross combining the OGKB v2.1 phenotype with Blue Sherb." },

  { id:"ogkb", name:"OGKB", aka:"OG Kush Breath, OGKB v2.1", type:"indica",
    parents:["Girl Scout Cookies phenotype"],
    grandparents:{"Girl Scout Cookies phenotype":["OG Kush","Durban Poison"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Unknown", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Earth","Sweet","Pine","Cookie"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"A heavy, indica-leaning Girl Scout Cookies phenotype that became a foundational parent for ThugPug and other boutique breeders." },

  { id:"blue-sherb", name:"Blue Sherb", aka:"Blue Sherbet", type:"hybrid",
    parents:["Blueberry","Sunset Sherbet"],
    grandparents:{"Blueberry":["Afghani","Thai","Purple Thai"],"Sunset Sherbet":["GSC","Pink Panties"]},
    thc:"19-23%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Unknown", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Berry","Sweet","Cream","Vanilla"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"A modern berry-and-cream hybrid combining DJ Short's Blueberry with Mr. Sherbinski's Sunset Sherbet." },

  { id:"money-shot", name:"Money Shot", aka:"Fermented Juicy Fruit", type:"hybrid",
    parents:["Drippy Eye","Meat Breath F2"],
    grandparents:{"Drippy Eye":["Juicy Fruit Thai","Snow Lotus","Star Pupil"],"Meat Breath F2":["Unknown","MendoBreath F2"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Mass Medical Strains (attributed)", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Tropical","Fruit","Funk","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A complex East Coast cross. Used as the female parent in Light Seeker's Heart Shot F1." },

  { id:"drippy-eye", name:"Drippy Eye", type:"hybrid",
    parents:["Juicy Fruit Thai","Snow Lotus","Star Pupil"],
    grandparents:{"Star Pupil":["Chemdawg D","Pre-98 Bubba Kush"]},
    thc:"20-24%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Tropical","Sweet","Fruit","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Mass Medical Strains release combining the heritage Juicy Fruit Thai with Bodhi's Snow Lotus and Mass Medical's own Star Pupil." },

  { id:"juicy-fruit-thai", name:"Juicy Fruit Thai", aka:"Juicy Fruit, JFT", type:"sativa",
    parents:["Thai Landrace phenotype"],
    grandparents:{},
    thc:"15-20%", cbd:"<0.5%", flowering:"70-84 days",
    breeder:"Sensi Seeds (heritage release)", origin:"Thailand → Netherlands",
    terpenes:["Terpinolene","Limonene","Myrcene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Tropical","Fruit","Sweet","Citrus"],
    medical:["Fatigue","Depression","Stress"],
    desc:"A heritage Thai sativa selection released by Sensi Seeds known for its overwhelming tropical-fruit aromatic." },

  { id:"snow-lotus", name:"Snow Lotus", type:"hybrid",
    parents:["Afgooey","Blockhead"],
    grandparents:{"Afgooey":["Maui Haze","Afghani"],"Blockhead":["Sweet Tooth","Sensi Star"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Floral","Earth","Pine"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Bodhi Seeds' celebrated father plant — used as the male in Goji OG, Mothers Milk, and many other Bodhi releases." },

  { id:"meat-breath", name:"Meat Breath", aka:"Meat Breath F2", type:"indica",
    parents:["Unknown","MendoBreath F2"],
    grandparents:{"MendoBreath F2":["OGKB","MendoMontage"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Earth","Funk","Pine","Sweet"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A Mass Medical Strains release built on a MendoBreath F2 base." },

  { id:"mendobreath", name:"MendoBreath", aka:"MendoBreath F2", type:"indica",
    parents:["OGKB","MendoMontage"],
    grandparents:{"OGKB":["Girl Scout Cookies"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"ThugPug Genetics", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Earth","Sweet","Cream","Caramel"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"One of the most genetically influential indicas of the late 2010s." },

  { id:"peanut-butter-breath", name:"Peanut Butter Breath", aka:"PB Breath, OGKB pheno", type:"indica",
    parents:["Do-Si-Dos","Mendobreath F2"],
    grandparents:{"Do-Si-Dos":["GSC","Face Off OG"],"Mendobreath F2":["OGKB","MendoMontage"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"ThugPug Genetics", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Peanut","Nutty","Earth","Sweet"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"ThugPug's celebrated nut-and-cookie indica." },

  { id:"hella-jelly", name:"Hella Jelly", type:"hybrid",
    parents:["Very Cherry","Notorious THC"],
    grandparents:{},
    thc:"22-29%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Humboldt Seed Company", origin:"Humboldt County, CA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Cherry","Berry","Sweet","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Humboldt Seed Company's celebrated cherry-and-tropical hybrid. Used as the female parent in Light Seeker's Lime Jelly." },

  { id:"very-cherry", name:"Very Cherry", aka:"Humboldt Very Cherry", type:"hybrid",
    parents:["Cherry phenotype"],
    grandparents:{},
    thc:"19-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Humboldt Seed Company", origin:"Humboldt County, CA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Cherry","Sweet","Berry","Candy"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"Humboldt Seed Company's cherry-forward hybrid known for its bright, candy-like aromatic." },

  { id:"notorious-thc", name:"Notorious THC", type:"hybrid",
    parents:["Chemdawg lineage","High-THC selection"],
    grandparents:{},
    thc:"28-34%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Humboldt Seed Company", origin:"Humboldt County, CA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Euphoric","Relaxed","Happy","Sleepy"],
    flavors:["Diesel","Earth","Pine","Citrus"],
    medical:["Pain","Stress","Insomnia","Depression"],
    desc:"Humboldt Seed Company's high-THC flagship — bred specifically to push the upper limits of cannabinoid production." },

  { id:"kosher-kush", name:"Kosher Kush", aka:"Jew Gold, Kosher OG", type:"indica",
    parents:["Unknown OG Kush phenotype"],
    grandparents:{"Unknown OG Kush phenotype":["Chemdawg","Hindu Kush"]},
    thc:"21-25%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"DNA Genetics / Reserva Privada", origin:"Los Angeles, CA",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Earth","Pine","Fuel","Sweet"],
    medical:["Pain","Insomnia","Stress","Appetite Loss"],
    desc:"DNA Genetics' multiple Cannabis Cup winner — Best Indica 2010 and 2011. Used as a father parent in both Light Seeker's Lime Jelly and Elote." },

  { id:"francos-lemon-cheese", name:"Francos Lemon Cheese", aka:"FLC, Lemon Cheese", type:"hybrid",
    parents:["Super Lemon Haze","Exodus Cheese"],
    grandparents:{"Super Lemon Haze":["Lemon Skunk","Super Silver Haze"],"Exodus Cheese":["Skunk #1 phenotype"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"UK clone-only (attributed to Franco)", origin:"United Kingdom",
    terpenes:["Terpinolene","Limonene","Caryophyllene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Lemon","Cheese","Citrus","Pungent"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"A UK clone-only hybrid combining Super Lemon Haze with the legendary Exodus Cheese cut. Used as the female parent in Light Seeker's Elote." },

]);


/* ── BATCH 2 — UPCOMING-CROSS INVENTORY (50 strains) ─────────── */
window.LSS_REFERENCE = window.LSS_REFERENCE.concat([

  { id:"pure-land-hashplant", name:"Pure Land Hashplant", type:"indica",
    parents:["Congo x Kashmir","88 G13/HP"],
    grandparents:{"88 G13/HP":["G13","Hashplant"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Hash","Earth","Pine","Spicy"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A Bodhi Seeds release combining a Congo x Kashmir mother with the iconic 88 G13/HP father." },

  { id:"more-cowbell", name:"More Cowbell", type:"hybrid",
    parents:["Thin Mint GSC","88 G13/HP"],
    grandparents:{"Thin Mint GSC":["OG Kush Breath","F1 Durb"],"88 G13/HP":["G13","Hashplant"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Mint","Hash","Sweet","Cookie"],
    medical:["Stress","Pain","Anxiety","Insomnia"],
    desc:"Bodhi's cross of the Thin Mint GSC cut onto the 88 G13/HP father." },

  { id:"silver-unicorn", name:"Silver Unicorn", type:"sativa",
    parents:["Super Silver Haze","Purple Unicorn F3"],
    grandparents:{"Super Silver Haze":["Skunk","Northern Lights","Haze"],"Purple Unicorn F3":["Purple Unicorn"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"63-77 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Terpinolene","Caryophyllene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Citrus","Skunk","Sweet","Floral"],
    medical:["Depression","Fatigue","Stress","Pain"],
    desc:"A Bodhi cross of Super Silver Haze with their Purple Unicorn F3 father." },

  { id:"black-hole-sun", name:"Black Hole Sun", type:"hybrid",
    parents:["Black Triangle","Sunshine Daydream","Anaphylaxis"],
    grandparents:{"Black Triangle":["Triangle Kush","Black Cherry Soda"],"Sunshine Daydream":["Appalachia","Bubba Kush"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Earth","Pine","Sweet","Berry"],
    medical:["Pain","Stress","Anxiety","Depression"],
    desc:"A Mass Medical three-way cross." },

  { id:"golden-putang", name:"Golden Putang", type:"hybrid",
    parents:["Golden Pineapple","Putang"],
    grandparents:{"Golden Pineapple":["Golden Goat","Pineapple"],"Putang":["Tang Tang","Crystal Locomotive"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Terpinolene","Limonene","Myrcene"],
    effects:["Happy","Uplifted","Energetic","Creative"],
    flavors:["Pineapple","Tropical","Citrus","Sweet"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"Mass Medical's tropical-fruit hybrid." },

  { id:"prayer-pupil", name:"Prayer Pupil", type:"hybrid",
    parents:["Star Pupil","Prayer Tower"],
    grandparents:{"Star Pupil":["Chemdawg D","Pre-98 Bubba Kush"],"Prayer Tower":["Appalachia","Mountain Temple"]},
    thc:"20-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Earth","Pine","Sweet","Diesel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Mass Medical workhorse." },

  { id:"old-smuggler", name:"Old Smuggler", type:"sativa",
    parents:["Psyche","Swabi Pakistani"],
    grandparents:{"Swabi Pakistani":["Pakistani Landrace"]},
    thc:"15-19%", cbd:"<1%", flowering:"63-77 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Pinene","Myrcene","Caryophyllene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Earth","Pine","Sweet","Hash"],
    medical:["Stress","Depression","Fatigue"],
    desc:"A heritage-leaning Mass Medical cross pulling Pakistani landrace genetics into a modern hybrid frame." },

  { id:"heritage-haze-f2", name:"Heritage Haze F2", type:"sativa",
    parents:["Super Lemon Haze (Franco's cut)","Nevil's Haze"],
    grandparents:{"Super Lemon Haze (Franco's cut)":["Lemon Skunk","Super Silver Haze"],"Nevil's Haze":["Northern Lights #5","Haze"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"77-91 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Terpinolene","Limonene","Caryophyllene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Lemon","Citrus","Earth","Spicy"],
    medical:["Depression","Fatigue","Stress","Pain"],
    desc:"Mass Medical's preservation cross." },

  { id:"purple-glue-stick", name:"Purple Glue Stick", type:"hybrid",
    parents:["Star Pupil","Prayer Glue 7"],
    grandparents:{"Star Pupil":["Chemdawg D","Pre-98 Bubba Kush"]},
    thc:"20-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Earth","Pine","Glue"],
    medical:["Stress","Pain","Anxiety"],
    desc:"A Mass Medical release." },

  { id:"grape-pupil", name:"Grape Pupil", type:"hybrid",
    parents:["Star Pupil","Putang"],
    grandparents:{"Star Pupil":["Chemdawg D","Pre-98 Bubba Kush"],"Putang":["Tang Tang","Crystal Locomotive"]},
    thc:"20-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Grape","Sweet","Earth","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Mass Medical cross of two of their signature parents." },

  { id:"mocha-lope-v3", name:"Mocha Lope V3", type:"hybrid",
    parents:["Oregon Afghani","Chocolate Rain F2"],
    grandparents:{"Chocolate Rain F2":["Chocolate Rain"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Relic Seeds", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Coffee","Chocolate","Earth","Wood"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"Relic Seeds' third version of their Mocha Lope line." },

  { id:"blueberry-starfighter-x-exodus-cheese", name:"Blueberry Starfighter × Exodus Cheese #1", type:"hybrid",
    parents:["Blueberry Starfighter","Exodus Cheese"],
    grandparents:{"Blueberry Starfighter":["Blueberry","Starfighter"],"Exodus Cheese":["Skunk #1 phenotype"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Relic Seeds", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Hungry"],
    flavors:["Berry","Cheese","Sweet","Pungent"],
    medical:["Stress","Pain","Anxiety","Appetite Loss"],
    desc:"A Relic Seeds release." },

  { id:"relic-ssh-ibl", name:"Relic Super Silver Haze IBL", aka:"'98 HTCC Winner SSH IBL", type:"sativa",
    parents:["'98 HTCC SSH cut","Super Silver Haze F3"],
    grandparents:{"'98 HTCC SSH cut":["Super Silver Haze"],"Super Silver Haze F3":["Skunk","Northern Lights","Haze"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"63-77 days",
    breeder:"Relic Seeds", origin:"USA",
    terpenes:["Terpinolene","Caryophyllene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Citrus","Skunk","Earth","Spicy"],
    medical:["Depression","Fatigue","Stress","Pain"],
    desc:"Relic's preservation work on the legendary 1998 High Times Cannabis Cup-winning Super Silver Haze cut." },

  { id:"grapefruit-ibl-pnw", name:"Grapefruit IBL PNW Cut", type:"sativa",
    parents:["Grapefruit IBL","Relic Grapefruit"],
    grandparents:{"Grapefruit IBL":["Grapefruit"],"Relic Grapefruit":["Grapefruit IBL","Grapefruit F3"]},
    thc:"15-20%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Relic Seeds", origin:"Pacific Northwest, USA",
    terpenes:["Limonene","Myrcene","Caryophyllene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Grapefruit","Citrus","Sweet","Tropical"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"Relic Seeds' Pacific Northwest preservation of the Grapefruit IBL line." },

  { id:"citradelic-sunset", name:"Citradelic Sunset", type:"sativa",
    parents:["Ghost Train Haze","Mandarin Sunset"],
    grandparents:{"Ghost Train Haze":["Ghost OG","Neville's Wreck"],"Mandarin Sunset":["Herojuana","Orange Skunk"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Ethos Genetics", origin:"USA",
    terpenes:["Terpinolene","Limonene","Caryophyllene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Citrus","Orange","Tropical","Sweet"],
    medical:["Depression","Fatigue","Stress","Pain"],
    desc:"Ethos Genetics' high-THC citrus-forward sativa." },

  { id:"mescaline", name:"Mescaline", type:"hybrid",
    parents:["Lilac Poison","Lilac Diesel BX"],
    grandparents:{"Lilac Diesel BX":["Lilac Diesel"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"Pacha's Select", origin:"USA",
    terpenes:["Terpinolene","Myrcene","Caryophyllene"],
    effects:["Happy","Uplifted","Euphoric","Creative"],
    flavors:["Floral","Diesel","Sweet","Lilac"],
    medical:["Stress","Depression","Anxiety","Pain"],
    desc:"A Pacha's Select cross." },

  { id:"florida-man", name:"Florida Man", type:"hybrid",
    parents:["3D","Datura"],
    grandparents:{"3D":["Swamp Boys lineage"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Pacha's Select (Cody)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Earth","Sweet","Diesel","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Pacha's Select cross by Cody combining 3D from Swamp Boys Seeds with the Datura father." },

  { id:"grapestomper-og-bx", name:"Grapestomper OG BX", type:"hybrid",
    parents:["Grape Stomper OG","Mac Stomper"],
    grandparents:{"Grape Stomper OG":["Grape Stomper","OG Kush"],"Mac Stomper":["MAC","Grape Stomper"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Sunken Treasure Seeds", origin:"West Coast, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Grape","Pine","Earth","Fuel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Sunken Treasure Seeds backcross." },

  { id:"power-purp", name:"Power Purp", type:"hybrid",
    parents:["Mendo Purp","Blue Power"],
    grandparents:{"Mendo Purp":["Unknown"],"Blue Power":["Master Kush","Blueberry","Sour Double","The White","Blue Moonshine"]},
    thc:"19-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Sunken Treasure Seeds", origin:"West Coast, USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Blueberry","Grape","Gas","Sweet"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A legendary combo of the heavily sought after Mendo Purp line — Mendo Purp was purple before it was popular to be purple. If the color purple had a smell it would be Mendo Purp. Combined with the legendary Blue Power by Sin City Seeds — a grandparent or great-grandparent to many popular strains today — this is a great union of purple and blue." },

  { id:"sapphire-scout", name:"Sapphire Scout", type:"hybrid",
    parents:["Girl Scout Cookies","True OG"],
    grandparents:{"Girl Scout Cookies":["OG Kush","Durban Poison"],"True OG":["OG Kush phenotype"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Humboldt Seed Organisation", origin:"Humboldt County, CA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Cookie","Earth","Pine","Sweet"],
    medical:["Pain","Stress","Insomnia","Anxiety"],
    desc:"Humboldt Seed Organisation's cross." },

  { id:"crumpets-fc", name:"Crumpets", type:"hybrid",
    parents:["3 Kings × LPC","Cereal Milk"],
    grandparents:{"3 Kings × LPC":["3 Kings","London Pound Cake"],"Cereal Milk":["Snowman","Y Life"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Fat Cat Seeds", origin:"Maine, USA (outdoor)",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Cream","Cake","Berry"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Fat Cat Seeds release. Fat Cat is a Maine outdoor breeding collective." },

  { id:"el-cielo-fc", name:"El Cielo", type:"hybrid",
    parents:["Los Celos","Sherbinski cross"],
    grandparents:{"Los Celos":["Umami","Saherbinski"],"Sherbinski cross":["Sunset Sherbet","Zuchi","Ice Cream Cake"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Fat Cat Seeds", origin:"Maine, USA (outdoor)",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Cream","Berry","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A complex Fat Cat Seeds cross." },

  { id:"grease-fire-fc", name:"Grease Fire", type:"hybrid",
    parents:["Blue Grease","Gorilla Fire"],
    grandparents:{"Blue Grease":["Grease","Blueberry (DJ Short)"],"Gorilla Fire":["GG4","Fire OG"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Fat Cat Seeds", origin:"Maine, USA (outdoor)",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Diesel","Berry","Earth","Fuel"],
    medical:["Pain","Stress","Insomnia","Anxiety"],
    desc:"A Fat Cat Seeds gas-and-berry hybrid." },

  { id:"menemsha-sunset-x-rumcakez", name:"Menemsha Sunset × Rumcakez", type:"hybrid",
    parents:["Menemsha Sunset","Rumcakez"],
    grandparents:{"Menemsha Sunset":["Purple Tangie","Red Spangled Banner"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Fat Cat Seeds", origin:"Maine, USA (outdoor)",
    terpenes:["Limonene","Caryophyllene","Myrcene"],
    effects:["Happy","Relaxed","Uplifted","Creative"],
    flavors:["Citrus","Sweet","Tropical","Cream"],
    medical:["Stress","Anxiety","Depression","Pain"],
    desc:"A Fat Cat Seeds cross." },

  { id:"rumchata-fc", name:"Rumchata", type:"hybrid",
    parents:["Cereal Milk","Rumcakez"],
    grandparents:{"Cereal Milk":["Snowman","Y Life"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Fat Cat Seeds", origin:"Maine, USA (outdoor)",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cream","Sweet","Vanilla","Cinnamon"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Fat Cat Seeds dessert hybrid." },

  { id:"lung-buster", name:"Lung Buster", type:"indica",
    parents:["Don Mega","Udder Madness"],
    grandparents:{},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Solfire Gardens", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Sleepy","Euphoric","Hungry"],
    flavors:["Earth","Sweet","Cream","Pungent"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A Solfire Gardens indica-leaning hybrid." },

  { id:"strawnapple", name:"Strawnapple", type:"hybrid",
    parents:["Purple Pineapple","Garry Poppins"],
    grandparents:{"Purple Pineapple":["Purple Punch","Pineapple"],"Garry Poppins":["Sundae Driver","Trop Cookies"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Exotic Genetix", origin:"USA",
    terpenes:["Limonene","Caryophyllene","Myrcene"],
    effects:["Happy","Relaxed","Uplifted","Creative"],
    flavors:["Strawberry","Pineapple","Sweet","Tropical"],
    medical:["Stress","Anxiety","Depression","Pain"],
    desc:"An Exotic Genetix tropical-fruit hybrid." },

  { id:"1969-lit", name:"1969", type:"indica",
    parents:["2090 Sh*t","Zoap"],
    grandparents:{"Zoap":["Pink Guava","Rainbow Sherbet 11"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Lit Farms", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Sweet","Candy","Tropical","Berry"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"A new Lit Farms release." },

  { id:"purple-trainwreck-bagseed", name:"Purple Trainwreck (LSS Bagseed Selection)", type:"sativa",
    parents:["Trainwreck phenotype"],
    grandparents:{"Trainwreck phenotype":["Mexican","Thai","Afghani"]},
    thc:"18-22%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Unknown (LSS bagseed)", origin:"Massachusetts, USA",
    terpenes:["Terpinolene","Myrcene","Pinene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Pine","Earth","Sweet","Lemon"],
    medical:["Stress","Depression","Fatigue"],
    desc:"A Light Seeker Seeds bagseed hunt found in a particularly dank batch of Purple Trainwreck. Likely from accidental pollination, the resulting plants carry the unmistakable Trainwreck aromatic profile but with completely purple, airy, hazey bud structure." },

  { id:"chem-cookies-mamiko", name:"Chem Cookies", aka:"GMO, GMO Cookies, Garlic Cookies", type:"hybrid",
    parents:["Chem 4","GSC (Forum cut)"],
    grandparents:{"Chem 4":["Chemdawg"],"GSC (Forum cut)":["OG Kush","Durban Poison"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Mamiko Seeds", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Garlic","Cookie","Earth","Fuel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A celebrated Mamiko Seeds cross. Most famous for producing the GMO phenotype — a strain that became a worldwide hit for its distinctive garlic flavor and aroma." },

  { id:"peach-junky", name:"Peach Junky", type:"hybrid",
    parents:["Blue Buddha","Chem Junky"],
    grandparents:{},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Unknown (Harvest Cup 2024 acquisition)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Relaxed","Uplifted","Creative"],
    flavors:["Peach","Sweet","Diesel","Earth"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"A boutique cross of Blue Buddha with Chem Junky, acquired by Light Seeker Seeds at the 2024 Harvest Cup." },

  { id:"cheesy-rider-bagseed", name:"Cheesy Rider (Bagseed)", type:"hybrid",
    parents:["Exodus Cheese","Biker Kush V1.0 (HA-OG BX1)"],
    grandparents:{"Exodus Cheese":["Skunk #1 phenotype"],"Biker Kush V1.0 (HA-OG BX1)":["Hells Angel OG","Lucky Charms"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Karma Genetics (attributed)", origin:"Netherlands",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cheese","Earth","Pungent","Pine"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A bagseed find likely originating from Karma Genetics." },

  { id:"rainbow-chip-f2", name:"Rainbow Chip F2", type:"hybrid",
    parents:["Rainbow Chip","Rainbow Chip"],
    grandparents:{"Rainbow Chip":["Sunset Sherbet","Mint Chocolate Chip"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Rainbow House Seed Co (Exotic Genetix line)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Mint","Cream","Berry"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"Rainbow House Seed Co's F2 inbreeding of the Rainbow Chip line." },

  { id:"rainbow-panty-dropper-f1", name:"Rainbow Panty Dropper F1", type:"hybrid",
    parents:["Rainbow Chip","Purple Panty Dropper"],
    grandparents:{"Rainbow Chip":["Sunset Sherbet","Mint Chocolate Chip"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Rainbow House Seed Co", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Berry","Cream","Tropical"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"A Rainbow House Seed Co F1 cross." },

  { id:"puna-cherry-d", name:"Puna Cherry D", type:"hybrid",
    parents:["Puna Diesel","Glazed Cherries F5"],
    grandparents:{"Puna Diesel":["Hawaiian","Sour Diesel"],"Glazed Cherries F5":["Glazed Cherries"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"Hawaiian Budline", origin:"Hawaii, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Uplifted","Euphoric","Creative"],
    flavors:["Cherry","Diesel","Tropical","Sweet"],
    medical:["Depression","Stress","Pain","Fatigue"],
    desc:"A Hawaiian Budline release." },

  { id:"skywalker-og-bx1-leo", name:"Skywalker OG BX1", type:"indica",
    parents:["Skywalker OG","Skywalker OG × Larry OG BX1"],
    grandparents:{"Skywalker OG":["Skywalker","OG Kush"],"Skywalker OG × Larry OG BX1":["Skywalker OG","Larry OG"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Aficionado (Leo Stone)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Pine","Citrus","Diesel","Earth"],
    medical:["Pain","Insomnia","Stress","Appetite Loss"],
    desc:"Leo Stone's Aficionado preservation of the Skywalker OG line." },

  { id:"rainbow-larry", name:"Rainbow Larry", type:"hybrid",
    parents:["RS11","Larry OG BX3"],
    grandparents:{"RS11":["Rainbow Sherbet"],"Larry OG BX3":["Lemon Larry OG","SFV OG"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Aficionado (Leo Stone)", origin:"USA",
    terpenes:["Limonene","Caryophyllene","Myrcene"],
    effects:["Happy","Relaxed","Uplifted","Euphoric"],
    flavors:["Lemon","Citrus","Sweet","Berry"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A union of the legendary Larry OG with the modern hype RS11." },

  { id:"voodoo-larry", name:"Voodoo Larry", type:"hybrid",
    parents:["Triangle Kush","Larry OG BX2"],
    grandparents:{"Triangle Kush":["OG Kush"],"Larry OG BX2":["Larry OG","Larry OG BX1"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Aficionado (Leo Stone)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Lemon","Pine","Earth","Fuel"],
    medical:["Stress","Pain","Anxiety","Insomnia"],
    desc:"A union of two absolute legends and backbones to many popular strains today — Triangle Kush and Larry OG." },

  { id:"chem-91-bx", name:"Chem 91 BX", type:"hybrid",
    parents:["Chem 91","Chem 91"],
    grandparents:{"Chem 91":["Chemdawg"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"The Real Uncle Doobie", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Euphoric","Happy","Relaxed","Creative"],
    flavors:["Diesel","Chemical","Earth","Pungent"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"Uncle Doobie's preservation backcross of the legendary Chem 91 cut." },

  { id:"pure-kush-x-30-year-dog", name:"Pure Kush × 30 Year Dog", type:"hybrid",
    parents:["Pure Kush","30 Year Dog"],
    grandparents:{"30 Year Dog":["Sour A Cut","Chem Fuego"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"The Real Uncle Doobie", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Euphoric","Happy","Sleepy"],
    flavors:["Earth","Diesel","Pine","Fuel"],
    medical:["Pain","Stress","Insomnia","Anxiety"],
    desc:"Uncle Doobie's heritage cross." },

  { id:"gas-gpt", name:"Gas GPT", type:"hybrid",
    parents:["GMO","Sour Diesel BX 2.5"],
    grandparents:{"GMO":["Chem 4","GSC"],"Sour Diesel BX 2.5":["Sour Diesel"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"The Real Uncle Doobie", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Euphoric","Happy","Creative"],
    flavors:["Garlic","Diesel","Fuel","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Uncle Doobie's gas-on-gas hybrid." },

  { id:"slimeball-3-x-ogeeze", name:"Slimeball #3 × Ogeeze", type:"hybrid",
    parents:["Slimeball #3","Ogeeze"],
    grandparents:{"Slimeball #3":["Slurricane","Grape Balls of Fire","Mac Stomper"],"Ogeeze":["Legend Orange Apricot F2","Oz Kush"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Green Lab Genetics (Phenohuntr)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Grape","Citrus","Sweet","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Phenohuntr / Green Lab Genetics cross." },

  { id:"black-blu-magoo", name:"Black Blu Magoo", type:"hybrid",
    parents:["Purple Punch","Blue Heron #111"],
    grandparents:{"Purple Punch":["Larry OG","Granddaddy Purple"],"Blue Heron #111":["Blue Magoo","Oregon Huckleberry"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Dynasty Genetics", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Linalool"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Berry","Grape","Sweet","Floral"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"A Dynasty Genetics cross of Purple Punch with the Blue Heron #111 phenotype." },

  { id:"grape-glue", name:"Grape Glue", type:"indica",
    parents:["Grapes (Starlabs)","Gorilla Glue #4"],
    grandparents:{"Grapes (Starlabs)":["Grape Stomper","Chief"],"Gorilla Glue #4":["Chem's Sister","Chocolate Diesel","Sour Dubb"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Starlabs", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Grape","Diesel","Earth","Pine"],
    medical:["Pain","Stress","Insomnia","Anxiety"],
    desc:"A Starlabs cross combining their Grapes line with the legendary GG4." },

  { id:"grape-nami", name:"Grape Nami", type:"hybrid",
    parents:["Grapes (Starlabs)","Nami"],
    grandparents:{"Grapes (Starlabs)":["Grape Stomper","Chief"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Starlabs", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Grape","Sweet","Earth","Berry"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Starlabs cross." },

  { id:"grape-han", name:"Grape Han", type:"hybrid",
    parents:["Grapes (Starlabs)","Han Solo Hashplant"],
    grandparents:{"Grapes (Starlabs)":["Grape Stomper","Chief"]},
    thc:"20-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Starlabs", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Grape","Hash","Earth","Pine"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"A Starlabs cross." },

  { id:"good-karma", name:"Good Karma", type:"hybrid",
    parents:["Sweet Jack Haze","Monty Gluethon"],
    grandparents:{},
    thc:"19-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Dank Flow Genetics", origin:"Massachusetts, USA",
    terpenes:["Limonene","Caryophyllene","Terpinolene"],
    effects:["Happy","Uplifted","Relaxed","Creative"],
    flavors:["Citrus","Sweet","Earth","Pine"],
    medical:["Stress","Depression","Anxiety","Pain"],
    desc:"A feminized release from Dank Flow Genetics." },

  { id:"ridge-town", name:"Ridge Town", type:"hybrid",
    parents:["Sour Diesel BX3","Third Leg"],
    grandparents:{"Sour Diesel BX3":["Sour Diesel"],"Third Leg":["Salami Glue","Salami Leg"]},
    thc:"20-25%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"Dank Flow Genetics", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Diesel","Earth","Garlic","Fuel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A balanced hybrid from Dank Flow Genetics." },

  { id:"sister-haze-banana-d", name:"Sister Haze Banana D", type:"hybrid",
    parents:["Original Haze","Chem Sis","Banana Dog #53"],
    grandparents:{"Original Haze":["Colombian","Mexican","Thai","South Indian"],"Chem Sis":["Chemdawg"],"Banana Dog #53":["Banana Z","Chem 91","Chem"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"63-77 days",
    breeder:"Chem Dog", origin:"USA",
    terpenes:["Caryophyllene","Terpinolene","Myrcene"],
    effects:["Energetic","Happy","Euphoric","Creative"],
    flavors:["Diesel","Citrus","Banana","Earth"],
    medical:["Stress","Depression","Pain","Fatigue"],
    desc:"A 2025 Chem Dog release." },

  { id:"cookie-killer", name:"Cookie Killer", type:"hybrid",
    parents:["Cherry Pie Kush II","Grapes II"],
    grandparents:{"Cherry Pie Kush II":["Original Cherry Pie Kush"],"Grapes II":["Grape Stomper","AQUA"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cherry","Grape","Earth","Sweet"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A 2025 Gage Green Group release." },

  { id:"beethoven-ggg", name:"Beethoven", type:"hybrid",
    parents:["Mendo Breath","NYCSD"],
    grandparents:{"Mendo Breath":["OGKB","Mendo Montage"],"NYCSD":["Sour Diesel"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Earth","Diesel","Cream","Sweet"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Gage Green Group's cross of Mendo Breath with NYCSD — the rare original 1990s New York City Sour Diesel cut." }

]);
/* ── BATCH 3A — HERITAGE STRAIN GAPS ────────────────────────── */
window.LSS_REFERENCE = window.LSS_REFERENCE.concat([

  { id:"super-skunk", name:"Super Skunk", aka:"SSk", type:"hybrid",
    parents:["Skunk #1","Afghani"],
    grandparents:{"Skunk #1":["Acapulco Gold","Colombian Gold","Afghani"]},
    thc:"15-19%", cbd:"<0.5%", flowering:"49-56 days",
    breeder:"Sensi Seeds", origin:"Netherlands",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Hungry"],
    flavors:["Skunk","Earth","Sweet","Pungent"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A 1990 Sensi Seeds release that intensified the original Skunk #1 by backcrossing it to a heavy Afghani indica. Super Skunk became one of the most influential breeding parents of the 1990s and is the foundation of countless modern hybrids — Sour Diesel, Headband, and Chocolate Diesel all trace back to it." },

  { id:"lemon-skunk", name:"Lemon Skunk", type:"hybrid",
    parents:["Skunk #1 phenotype","Skunk #1 phenotype"],
    grandparents:{},
    thc:"17-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"DNA Genetics", origin:"Netherlands / Las Vegas",
    terpenes:["Limonene","Myrcene","Caryophyllene"],
    effects:["Happy","Uplifted","Energetic","Creative"],
    flavors:["Lemon","Citrus","Sweet","Skunk"],
    medical:["Stress","Depression","Fatigue","Anxiety"],
    desc:"DNA Genetics' celebrated lemon-leaning Skunk #1 selection — a stabilized cross of two specially chosen lemon-phenotype Skunk parents. Lemon Skunk has been a foundational parent in countless modern citrus-forward hybrids, including Super Lemon Haze." },

  { id:"shiva-skunk", name:"Shiva Skunk", type:"indica",
    parents:["Northern Lights #5","Skunk #1"],
    grandparents:{"Northern Lights #5":["Afghani"],"Skunk #1":["Acapulco Gold","Colombian Gold","Afghani"]},
    thc:"15-19%", cbd:"<0.5%", flowering:"45-55 days",
    breeder:"Sensi Seeds", origin:"Netherlands",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Skunk","Earth","Pine","Sweet"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"A Sensi Seeds release combining the legendary Northern Lights #5 with Skunk #1 — two of the most foundational Dutch genetics ever bred. Shiva Skunk produces dense, resin-coated indica buds with a fast flowering time and a deeply skunky, hash-leaning aromatic." },

  { id:"pre-98-bubba-kush", name:"Pre-98 Bubba Kush", aka:"Pre-98 Bubba", type:"indica",
    parents:["OG Kush phenotype","Northern Lights phenotype"],
    grandparents:{},
    thc:"19-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Heritage cut (Matt Bubba Berger, attributed)", origin:"USA — late 1990s",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Coffee","Earth","Hash","Chocolate"],
    medical:["Pain","Insomnia","Stress","Muscle Spasms"],
    desc:"A pre-1998 heritage cut of Bubba Kush, named after Matt 'Bubba' Berger who is credited with its early circulation. The Pre-98 phenotype is the original heavy, earthy, body-melting Bubba expression. A foundational parent in countless modern indicas including Star Pupil and many Mass Medical releases." },

  { id:"pink-panties", name:"Pink Panties", type:"indica",
    parents:["Burmese Kush","Florida Kush"],
    grandparents:{},
    thc:"18-22%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Sherbinski / Cookies", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Sweet","Berry","Cream","Floral"],
    medical:["Stress","Pain","Anxiety","Insomnia"],
    desc:"A Sherbinski/Cookies indica combining Burmese Kush with Florida Kush. Pink Panties is best known as the father of Sunset Sherbet, making it a foundational grandparent across the entire modern Sherbet/Gelato/Cookies hybrid universe." },

  { id:"alien-cookies", name:"Alien Cookies", type:"hybrid",
    parents:["Alien Dawg","Girl Scout Cookies"],
    grandparents:{"Alien Dawg":["Alien Technology","Chemdawg"],"Girl Scout Cookies":["OG Kush","Durban Poison"]},
    thc:"21-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Capulator", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cookie","Earth","Sweet","Diesel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Capulator's foundational cross combining Alien Dawg with Girl Scout Cookies. Alien Cookies is most famous as the mother of MAC (Miracle Alien Cookies) — meaning it's the genetic backbone of the entire MAC family." },

  { id:"f1-durb", name:"F1 Durb", aka:"F1 Durban Poison", type:"sativa",
    parents:["Durban Poison phenotype"],
    grandparents:{"Durban Poison phenotype":["South African Landrace"]},
    thc:"15-19%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"South Africa → USA",
    terpenes:["Terpinolene","Myrcene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Pine","Sweet","Anise","Citrus"],
    medical:["Depression","Fatigue","Stress","Pain"],
    desc:"A specific F1 Durban Poison phenotype that became foundational to American boutique breeding. Notable as the sativa parent in Girl Scout Cookies and Thin Mint GSC — making it one of the most genetically influential pure-sativa cuts of the 21st century." },

  { id:"mint-chocolate-chip", name:"Mint Chocolate Chip", aka:"MCC", type:"hybrid",
    parents:["SinMint Cookies","Mint Cookies"],
    grandparents:{"SinMint Cookies":["Sinful OG","Cookies"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Exotic Genetix", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Mint","Cookie","Sweet","Chocolate"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"An Exotic Genetix release combining SinMint Cookies with Mint Cookies. Best known as the father of Rainbow Chip, Mint Chocolate Chip is now a foundational parent across the Rainbow House Seed Co line and many modern dessert hybrids." },

  { id:"sour-dubb", name:"Sour Dubb", aka:"Sour Dubble", type:"hybrid",
    parents:["Sour Diesel","Sour Bubble"],
    grandparents:{"Sour Diesel":["Chemdawg 91","Super Skunk"],"Sour Bubble":["Bubble Gum"]},
    thc:"19-24%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Top Dawg Seeds", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Energetic","Happy","Euphoric","Creative"],
    flavors:["Diesel","Sour","Bubblegum","Earth"],
    medical:["Depression","Stress","Pain","Anxiety"],
    desc:"Top Dawg Seeds' Sour Diesel × Sour Bubble cross — most famous as the sour-fuel mother in GG4 (Gorilla Glue #4). A foundational influence on the modern Glue and gas hybrid scene." },

  { id:"chem-4", name:"Chem 4", aka:"Chemdawg 4", type:"hybrid",
    parents:["Chemdawg phenotype"],
    grandparents:{"Chemdawg phenotype":["Chemdawg"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"63-70 days",
    breeder:"Heritage cut", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Diesel","Chemical","Earth","Pungent"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"One of the original Chemdawg phenotypes that emerged from the legendary Chemdawg seed run. Chem 4 is famous as the female parent in Chem Cookies (Mamiko Seeds) — and therefore the genetic backbone of GMO and the modern garlic/funk era of breeding." },

  { id:"appalachia", name:"Appalachia", type:"hybrid",
    parents:["Tres Dawg","Green Crack"],
    grandparents:{"Tres Dawg":["Chemdawg","Afghani #1"],"Green Crack":["Skunk #1"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Caryophyllene","Pinene","Myrcene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Earth","Pine","Sweet","Lemon"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"Bodhi Seeds' Appalachia is a Tres Dawg × Green Crack hybrid that has become one of his most genetically influential father plants. Used as the male in Mothers Milk, Space Monkey, Sunshine Daydream, and many other Bodhi releases." },

  { id:"fire-og", name:"Fire OG", type:"hybrid",
    parents:["OG Kush","SFV OG Kush"],
    grandparents:{"OG Kush":["Chemdawg","Hindu Kush"],"SFV OG Kush":["OG Kush phenotype"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cali Connection (heritage cut)", origin:"Los Angeles, CA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Pine","Lemon","Diesel","Earth"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A celebrated OG Kush hybrid combining the original OG Kush with the SFV OG Kush cut — producing one of the strongest, most resinous OG expressions in the modern catalog. Fire OG is known for its bright orange pistils, dense trichome production, and the characteristic OG fuel-and-pine signature pushed to its limits." },

  { id:"starfighter", name:"Starfighter", type:"hybrid",
    parents:["Lemon Alien Dawg","Alien Tahoe OG"],
    grandparents:{"Lemon Alien Dawg":["Lemon Thai","Alien Dawg"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"AlienGenetics", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Lemon","Earth","Pine","Diesel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"AlienGenetics' workhorse Lemon Alien Dawg × Alien Tahoe OG cross — best known as a parent in MAC (Miracle Alien Cookies) and the Blueberry Starfighter line." },

  { id:"purple-elephant", name:"Purple Elephant", type:"hybrid",
    parents:["Purple Urkle phenotype","Unknown"],
    grandparents:{},
    thc:"17-21%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Unknown (West Coast clone-only)", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Linalool"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Grape","Berry","Sweet","Floral"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"A West Coast clone-only purple-leaning hybrid with grape and berry aromatic dominance. Most famous as a parent in Grape Stomper (and therefore the entire Grape Stomper family — Grape Stomper OG, Mac Stomper, and the Sunken Treasure breeding line)." },

  { id:"big-bud", name:"Big Bud", type:"indica",
    parents:["Afghani","Northern Lights","Skunk #1"],
    grandparents:{},
    thc:"15-19%", cbd:"<0.5%", flowering:"49-56 days",
    breeder:"Sensi Seeds", origin:"USA → Netherlands",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Happy","Sleepy","Hungry"],
    flavors:["Earth","Sweet","Pine","Pungent"],
    medical:["Stress","Pain","Insomnia","Appetite Loss"],
    desc:"A 1980s American commercial indica brought to Sensi Seeds in the Netherlands during the Reagan-era crackdowns. Big Bud is named for its enormous flower yields and has been a foundational parent in countless commercial indica hybrids — including Granddaddy Purple, Purple Punch, and Cherry Pie." },

  { id:"g13", name:"G13", aka:"Government 13", type:"indica",
    parents:["Afghani phenotype"],
    grandparents:{},
    thc:"22-28%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Heritage cut (attributed to U.S. govt research)", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Earth","Pine","Hash","Sweet"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A legendary Afghani-derived indica mythologized as having been smuggled out of a U.S. government cannabis research facility at the University of Mississippi in the 1970s — the 'G13' name supposedly referring to Government Strain #13. G13 has been preserved in collector circles for decades and is the foundation of G13 Haze, 88 G13/HP (Bodhi), and countless heritage hybrids." },

  { id:"g13-haze", name:"G13 Haze", type:"hybrid",
    parents:["G13","Haze"],
    grandparents:{"G13":["Afghani phenotype"]},
    thc:"19-24%", cbd:"<0.5%", flowering:"63-77 days",
    breeder:"Mr. Nice Seedbank / Barney's Farm", origin:"Netherlands",
    terpenes:["Caryophyllene","Pinene","Myrcene"],
    effects:["Energetic","Happy","Euphoric","Creative"],
    flavors:["Earth","Pine","Spicy","Sweet"],
    medical:["Stress","Depression","Pain","Anxiety"],
    desc:"A celebrated Dutch hybrid combining the legendary G13 with classic Haze, producing a long-flowering, complex sativa-dominant cross. G13 Haze won the 2007 Cannabis Cup and has remained a heritage cup-winner reference point for breeders working with G13-derived genetics." },

  { id:"blue-power", name:"Blue Power", type:"hybrid",
    parents:["Master Kush","Blueberry","Sour Double","The White","Blue Moonshine"],
    grandparents:{},
    thc:"19-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Sin City Seeds", origin:"Las Vegas, USA",
    terpenes:["Myrcene","Caryophyllene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Berry","Blueberry","Sweet","Pine"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Sin City Seeds' complex polyhybrid stacking Master Kush, Blueberry, Sour Double, The White, and Blue Moonshine. Blue Power has become a key parent in Animal Mints, Apples and Bananas, and several other modern boutique releases." },

  { id:"strawberry-fields", name:"Strawberry Fields", type:"hybrid",
    parents:["Strawberry","Strawberry Cough phenotype"],
    grandparents:{},
    thc:"15-19%", cbd:"<1%", flowering:"56-63 days",
    breeder:"Sagarmatha Seeds", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Happy","Uplifted","Relaxed","Creative"],
    flavors:["Strawberry","Sweet","Berry","Earth"],
    medical:["Stress","Anxiety","Depression","Pain"],
    desc:"A Sagarmatha Seeds release stabilizing the strawberry aromatic profile through generations of careful selection. Best known as a parent in Strawberry Diesel and Strawberry Cough lineages." },

  { id:"california-orange", name:"California Orange", aka:"Cali O, California Orange Bud", type:"hybrid",
    parents:["Mexican Sativa","Afghani"],
    grandparents:{},
    thc:"15-19%", cbd:"<1%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"California, USA — 1980s",
    terpenes:["Limonene","Myrcene","Pinene"],
    effects:["Happy","Uplifted","Energetic","Creative"],
    flavors:["Orange","Citrus","Sweet","Earth"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"A California heritage strain from the 1980s that pioneered the citrus-orange aromatic profile in cannabis. California Orange has been used as a parent in Clementine, Tangie, and Forbidden Fruit." },

  { id:"mendomontage", name:"MendoMontage", aka:"Mendo Montage", type:"hybrid",
    parents:["Mendocino Purps","Crystal Locomotive"],
    grandparents:{"Mendocino Purps":["Mendocino heritage cut"],"Crystal Locomotive":["Trainwreck","Apollo 13","Space Queen"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Berry","Earth","Sweet","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Gage Green Group's Mendocino Purps × Crystal Locomotive cross. Best known as a foundational father in MendoBreath (ThugPug Genetics) and Meat Breath." },

  { id:"putang", name:"Putang", type:"sativa",
    parents:["Tang Tang","Crystal Locomotive"],
    grandparents:{"Tang Tang":["Sapphire OG","Agent Orange"],"Crystal Locomotive":["Trainwreck","Apollo 13","Space Queen"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Terpinolene","Limonene","Myrcene"],
    effects:["Happy","Uplifted","Energetic","Creative"],
    flavors:["Tropical","Citrus","Sweet","Tang"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"Mass Medical's signature Tang Tang × Crystal Locomotive cross. Putang is one of Mass Medical's most-used fathers, appearing in Golden Putang, Grape Pupil, and many other releases." },

  { id:"tang-tang", name:"Tang Tang", type:"sativa",
    parents:["Sapphire OG","Agent Orange"],
    grandparents:{"Agent Orange":["Orange Velvet","Jack the Ripper"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Mass Medical Strains (TGA Subcool collaboration)", origin:"USA",
    terpenes:["Terpinolene","Limonene","Caryophyllene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Orange","Citrus","Sweet","Tropical"],
    medical:["Depression","Stress","Fatigue","Pain"],
    desc:"A Sapphire OG × Agent Orange cross that pulls high-terpinolene citrus expression into a workable hybrid form. Tang Tang is the mother of Mass Medical's Putang line." },

  { id:"crystal-locomotive", name:"Crystal Locomotive", type:"sativa",
    parents:["Trainwreck","Apollo 13","Space Queen"],
    grandparents:{"Apollo 13":["Genius","Princess 75"],"Space Queen":["Romulan","Cinderella 99"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"TGA Subcool Seeds", origin:"USA",
    terpenes:["Terpinolene","Caryophyllene","Limonene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Sweet","Citrus","Earth","Pine"],
    medical:["Depression","Stress","Fatigue","Pain"],
    desc:"TGA Subcool Seeds' three-way cross stacking Trainwreck with Apollo 13 and Space Queen. A frequent parent in modern hybrids and a key grandparent in Mass Medical's Tang Tang/Putang program." },

  { id:"joseph-og", name:"Joseph OG", type:"indica",
    parents:["OG Kush phenotype"],
    grandparents:{"OG Kush phenotype":["Chemdawg","Hindu Kush"]},
    thc:"21-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Limonene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Earth","Pine","Lemon","Fuel"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"Gage Green Group's heritage OG Kush phenotype, used as the father in Grateful Breath. Joseph OG carries the deep earthy-fuel signature of the OG Kush family with the heavy resin production typical of Gage Green's OG line." },

  { id:"afgooey", name:"Afgooey", aka:"Afgoo", type:"indica",
    parents:["Maui Haze","Afghani"],
    grandparents:{"Maui Haze":["Maui Wowie","Haze"]},
    thc:"19-25%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Heritage cut (West Coast)", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Earth","Pine","Hash","Sweet"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A West Coast heritage cross of Maui Haze with Afghani. Most famous as the mother of Bodhi's Snow Lotus father plant, making Afgooey a key grandparent across the Bodhi catalog including Goji OG and Mothers Milk." },

  { id:"blockhead", name:"Blockhead", type:"hybrid",
    parents:["Sweet Tooth","Sensi Star"],
    grandparents:{"Sweet Tooth":["Hawaiian","Afghani","Nepalese"],"Sensi Star":["Afghani phenotype"]},
    thc:"19-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"TH Seeds", origin:"Netherlands",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Earth","Pine","Hash"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"TH Seeds' Sweet Tooth × Sensi Star cross — a multi-Cannabis Cup winner from the early 2000s. Blockhead is best known as the father plant in Bodhi's Snow Lotus." },

  { id:"mk-ultra", name:"MK Ultra", type:"hybrid",
    parents:["G13","OG Kush"],
    grandparents:{"G13":["Afghani phenotype"],"OG Kush":["Chemdawg","Hindu Kush"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"TH Seeds", origin:"Netherlands",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Earth","Pine","Sweet","Pungent"],
    medical:["Pain","Insomnia","Stress","Muscle Spasms"],
    desc:"TH Seeds' G13 × OG Kush cross, named after the CIA mind-control program for its intensely sedating effects. MK Ultra won multiple Cannabis Cups in the mid-2000s and has been used as a parent in CBD-leaning hybrids including ACDC and Cannatonic." },

  { id:"williams-wonder", name:"William's Wonder", type:"indica",
    parents:["Afghani phenotype"],
    grandparents:{},
    thc:"15-19%", cbd:"<0.5%", flowering:"42-49 days",
    breeder:"Heritage cut (Sensi Seeds)", origin:"Netherlands",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Earth","Sweet","Pine","Hash"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"A Sensi Seeds heritage Afghani indica known for its short, fast-flowering structure. William's Wonder has been used as a parent in early autoflower breeding — a foundational genetic in Lowryder, Quick One, and the early ruderalis-hybrid scene." },

  { id:"y-life", name:"Y Life", type:"hybrid",
    parents:["Cookies","Cherry Pie"],
    grandparents:{"Cookies":["GSC"],"Cherry Pie":["Granddaddy Purple","Durban Poison"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cookies / Powerzzzup Genetics", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cherry","Sweet","Cookie","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Cookies family cross combining Cookies with Cherry Pie. Y Life is most famous as a parent of Cereal Milk (along with Snowman)." },

  { id:"snowman", name:"Snowman", type:"hybrid",
    parents:["GSC phenotype"],
    grandparents:{"GSC phenotype":["OG Kush","Durban Poison"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cookies (heritage cut)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Cookie","Cream","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A frosty, dessert-leaning GSC phenotype that became the father plant in Cereal Milk. Snowman is named for its trichome-heavy, snowy appearance and produces a creamy, sweet cookie-and-cream aromatic." },

  { id:"cereal-milk", name:"Cereal Milk", type:"hybrid",
    parents:["Snowman","Y Life"],
    grandparents:{"Snowman":["GSC phenotype"],"Y Life":["Cookies","Cherry Pie"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cookies / Powerzzzup Genetics", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cream","Sweet","Cereal","Vanilla"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A celebrated Cookies family release combining Snowman with Y Life, producing the now-iconic 'cereal milk' aromatic. A frequent parent in Fat Cat Seeds' Crumpets and Rumchata." }

]);

/* ── BATCH 3B — PARENT GAP CLEANUP ──────────────────────────── */
window.LSS_REFERENCE = window.LSS_REFERENCE.concat([

  { id:"black-triangle", name:"Black Triangle", type:"hybrid",
    parents:["Triangle Kush","Black Cherry Soda"],
    grandparents:{"Triangle Kush":["OG Kush"],"Black Cherry Soda":["Black Cherry","Lavender"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Cherry","Earth","Pine","Fuel"],
    medical:["Pain","Stress","Insomnia","Anxiety"],
    desc:"A Mass Medical Strains hybrid combining Triangle Kush with Black Cherry Soda. Black Triangle marries the dense, gassy structure of TK with the fruity-purple aromatic of Black Cherry Soda — the mother of Black Hole Sun." },

  { id:"black-cherry-soda", name:"Black Cherry Soda", type:"hybrid",
    parents:["Black Cherry","Lavender"],
    grandparents:{},
    thc:"15-20%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Heritage cut (West Coast)", origin:"USA",
    terpenes:["Myrcene","Linalool","Caryophyllene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cherry","Berry","Floral","Sweet"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A heritage West Coast cross with bright cherry-and-floral aromatics that became a foundational parent in Mass Medical's Black Triangle line." },

  { id:"sunshine-daydream", name:"Sunshine Daydream", type:"hybrid",
    parents:["Appalachia","Bubba Kush"],
    grandparents:{"Appalachia":["Tres Dawg","Green Crack"],"Bubba Kush":["OG Kush phenotype","Northern Lights phenotype"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Caryophyllene","Myrcene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Earth","Pine","Sweet","Berry"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Bodhi Seeds' Appalachia × Bubba Kush cross — one of his best-known releases and a frequent parent in further Bodhi work and outside collaborations." },

  { id:"anaphylaxis", name:"Anaphylaxis", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Mass Medical Strains breeding line used as a parent in Black Hole Sun. Detailed lineage and characteristics for this specific cut are not publicly documented." },

  { id:"golden-pineapple", name:"Golden Pineapple", type:"sativa",
    parents:["Golden Goat","Pineapple"],
    grandparents:{"Golden Goat":["Hawaiian-Romulan","Island Sweet Skunk"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"USA",
    terpenes:["Limonene","Myrcene","Terpinolene"],
    effects:["Happy","Uplifted","Energetic","Creative"],
    flavors:["Pineapple","Tropical","Sweet","Citrus"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"A Golden Goat × Pineapple cross that produces an overwhelming tropical-pineapple aromatic with productive sativa-leaning effects. Used as the mother in Mass Medical's Golden Putang." },

  { id:"golden-goat", name:"Golden Goat", type:"sativa",
    parents:["Hawaiian-Romulan","Island Sweet Skunk"],
    grandparents:{"Hawaiian-Romulan":["Hawaiian","Romulan"],"Island Sweet Skunk":["Sweet Skunk","Skunk #1"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"63-70 days",
    breeder:"Mr. Dank (heritage cut)", origin:"Topeka, Kansas — USA",
    terpenes:["Terpinolene","Limonene","Myrcene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Tropical","Sour","Sweet","Skunk"],
    medical:["Stress","Depression","Fatigue","Pain"],
    desc:"A celebrated heritage cut from Topeka, Kansas, originating from Mr. Dank as an accidental cross of a male Hawaiian-Romulan with an Island Sweet Skunk mother." },

  { id:"prayer-tower", name:"Prayer Tower", type:"hybrid",
    parents:["Appalachia","Mountain Temple"],
    grandparents:{"Appalachia":["Tres Dawg","Green Crack"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Mass Medical Strains release combining Bodhi's Appalachia with the Mountain Temple line. Used as the father in Mass Medical's Prayer Pupil." },

  { id:"mountain-temple", name:"Mountain Temple", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Bodhi Seeds (attributed)", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A breeding line used as a grandparent in Mass Medical's Prayer Tower. Specific lineage details not publicly confirmed." },

  { id:"psyche", name:"Psyche", type:"sativa",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Mass Medical Strains breeding line used as the mother in their Old Smuggler release." },

  { id:"swabi-pakistani", name:"Swabi Pakistani", aka:"Swabi Hashplant", type:"indica",
    parents:["Pakistani Landrace"],
    grandparents:{},
    thc:"15-19%", cbd:"<1%", flowering:"56-63 days",
    breeder:"Heritage Pakistani landrace", origin:"Swabi, Pakistan",
    terpenes:["Myrcene","Caryophyllene","Pinene"],
    effects:["Relaxed","Sleepy","Happy","Hungry"],
    flavors:["Hash","Earth","Pine","Spicy"],
    medical:["Pain","Insomnia","Stress"],
    desc:"A heritage Pakistani landrace from the Swabi region — historically one of the most renowned hash-producing areas of the Hindu Kush mountains. Used as a parent in Mass Medical's Old Smuggler." },

  { id:"nevils-haze", name:"Nevil's Haze", aka:"Nevil Haze", type:"sativa",
    parents:["Northern Lights #5","Haze"],
    grandparents:{"Northern Lights #5":["Afghani"],"Haze":["Mexican","Colombian","Thai","South Indian"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"77-91 days",
    breeder:"Mr. Nice Seedbank (Nevil Schoenmakers)", origin:"Netherlands",
    terpenes:["Terpinolene","Caryophyllene","Pinene"],
    effects:["Energetic","Uplifted","Happy","Creative"],
    flavors:["Earth","Spicy","Pine","Sweet"],
    medical:["Depression","Fatigue","Stress","Pain"],
    desc:"A foundational Dutch Haze hybrid created by Nevil Schoenmakers, one of the founding fathers of European cannabis breeding. Used in Mass Medical's Heritage Haze F2." },

  { id:"prayer-glue-7", name:"Prayer Glue 7", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Mass Medical Strains", origin:"Massachusetts, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Mass Medical Strains breeding line used as the father in Purple Glue Stick. Specific lineage not publicly documented." },

  { id:"mendo-breath", name:"Mendo Breath", aka:"MendoBreath F1", type:"indica",
    parents:["OGKB","Mendo Montage"],
    grandparents:{"OGKB":["Girl Scout Cookies"],"Mendo Montage":["Mendocino Purps","Crystal Locomotive"]},
    thc:"19-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Earth","Caramel","Sweet","Cream"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"Gage Green Group's original Mendo Breath — combining OGKB with Mendo Montage to produce a heavy caramel-and-earth indica. The genetic foundation for the entire OGKB / Mendo Breath dessert-indica family." },

  { id:"mendo-montage", name:"Mendo Montage", type:"hybrid",
    parents:["Mendocino Purps","Crystal Locomotive"],
    grandparents:{"Mendocino Purps":["Mendocino heritage cut"],"Crystal Locomotive":["Trainwreck","Apollo 13","Space Queen"]},
    thc:"18-22%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Limonene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Berry","Earth","Sweet","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Gage Green Group's Mendocino Purps × Crystal Locomotive cross. The original Gage Green grandparent that, when crossed onto OGKB, became Mendo Breath." },

  { id:"nycsd", name:"NYCSD", aka:"New York City Sour Diesel, Original NYCSD", type:"sativa",
    parents:["Sour Diesel phenotype"],
    grandparents:{"Sour Diesel phenotype":["Chemdawg 91","Super Skunk"]},
    thc:"19-24%", cbd:"<0.5%", flowering:"63-77 days",
    breeder:"Heritage cut", origin:"New York City, USA — 1990s",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Diesel","Citrus","Earth","Fuel"],
    medical:["Depression","Stress","Fatigue","Pain"],
    desc:"The rare original 1990s New York City Sour Diesel cut — distinct from the more widely circulated East Coast Sour Diesel (ECSD) variant. Used as the father in Gage Green's Beethoven release." },

  { id:"original-cherry-pie-kush", name:"Original Cherry Pie Kush", aka:"CPK Heirloom, CPK II", type:"hybrid",
    parents:["Cherry Pie phenotype","Kush"],
    grandparents:{"Cherry Pie phenotype":["Granddaddy Purple","Durban Poison"]},
    thc:"20-24%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Mendocino Heritage (preserved by Gage Green Group)", origin:"Mendocino County, CA",
    terpenes:["Caryophyllene","Limonene","Pinene"],
    effects:["Happy","Relaxed","Uplifted","Euphoric"],
    flavors:["Cherry","Sweet","Berry","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Mendocino heirloom phenotype of Cherry Pie crossed into a Kush, preserved in the Mendocino family grapevine before the Cookies-era reshaped the GSC/CPK genetic landscape." },

  { id:"grapes-ii", name:"Grapes II", type:"hybrid",
    parents:["Grape Stomper","AQUA"],
    grandparents:{"Grape Stomper":["Sour Diesel","Purple Elephant"],"AQUA":["Gushers","Cherry Pie Kush Breath"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Grape","Berry","Sweet","Earth"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Gage Green Group's second-generation Grapes line, stacking Grape Stomper onto AQUA. Used as the father in their Cookie Killer release." },

  { id:"aqua", name:"AQUA", type:"hybrid",
    parents:["Gushers","Cherry Pie Kush Breath"],
    grandparents:{"Gushers":["Triangle Kush","Gelato #41"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Gage Green Group", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Cherry","Sweet","Berry","Cream"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Gage Green Group cross of Gushers with Cherry Pie Kush Breath. Used as a parent in Grapes II and the broader Gage Green Group breeding stack." },

  { id:"rs11", name:"RS11", aka:"Rainbow Sherbet 11, Pink Certz", type:"hybrid",
    parents:["Pink Guava","OZK"],
    grandparents:{"Pink Guava":["Guava","Pink Phenotype"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Wizard Trees", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sherbet","Sweet","Berry","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Wizard Trees' celebrated 'Rainbow Sherbet 11' (RS-11) — one of the most hyped boutique drops of the 2020s, known for its colorful, frosty buds and intense candy-sherbet aromatic." },

  { id:"rainbow-sherbet", name:"Rainbow Sherbet", type:"hybrid",
    parents:["Champagne","Blackberry"],
    grandparents:{"Champagne":["Hash Plant","Champagne phenotype"]},
    thc:"19-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Berry","Sweet","Cream","Tropical"],
    medical:["Stress","Anxiety","Pain","Depression"],
    desc:"A Champagne × Blackberry cross that became a foundational candy-leaning parent in modern boutique breeding. The genetic source for Wizard Trees' RS11 line." },

  { id:"30-year-dog", name:"30 Year Dog", type:"hybrid",
    parents:["Sour A Cut","Chem Fuego"],
    grandparents:{"Chem Fuego":["Sour D Hunter Mountain","56 Day Headband","Chem 91 BX"]},
    thc:"", cbd:"", flowering:"",
    breeder:"The Real Uncle Doobie / heritage stack", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A heritage stack from The Real Uncle Doobie combining Sour A with the Chem Fuego line. Used as the father in Pure Kush × 30 Year Dog." },

  { id:"sour-a-cut", name:"Sour A Cut", aka:"Sour A", type:"hybrid",
    parents:["Sour Diesel phenotype"],
    grandparents:{"Sour Diesel phenotype":["Chemdawg 91","Super Skunk"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A heritage Sour Diesel phenotype known as 'Sour A' in collector circles. Used as a component in Uncle Doobie's 30 Year Dog stack." },

  { id:"chem-fuego", name:"Chem Fuego", type:"hybrid",
    parents:["Sour D Hunter Mountain","56 Day Headband","Chem 91 BX"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage stack (Skunk VA / Uncle Doobie)", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A complex heritage Chem-and-Sour stack used by The Real Uncle Doobie as a component in 30 Year Dog." },

  { id:"banana-dog-53", name:"Banana Dog #53", type:"hybrid",
    parents:["Banana Z","Chem 91","Chem"],
    grandparents:{"Chem 91":["Chemdawg"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Chem Dog", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Chem Dog selection stacking Banana Z onto a Chem 91 × Chem cross. Used as a parent in the 2025 Sister Haze Banana D release." },

  { id:"banana-z", name:"Banana Z", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A banana-aromatic heritage cut used as a grandparent in Chem Dog's Banana Dog #53 selection. Specific lineage not publicly confirmed." },

  { id:"don-mega", name:"Don Mega", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Solfire Gardens", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Solfire Gardens breeding line used as the mother in Lung Buster. Specific lineage not publicly documented." },

  { id:"udder-madness", name:"Udder Madness", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Solfire Gardens", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Solfire Gardens breeding line used as the father in Lung Buster. Specific lineage not publicly documented." },

  { id:"true-og", name:"True OG", aka:"Kobe OG", type:"indica",
    parents:["OG Kush phenotype"],
    grandparents:{"OG Kush phenotype":["Chemdawg","Hindu Kush"]},
    thc:"21-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"Los Angeles, CA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Pine","Lemon","Earth","Fuel"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A heritage OG Kush phenotype from the Los Angeles clone scene, also known as Kobe OG. A multi-Cannabis Cup winner used as a parent in Humboldt Seed Organisation's Sapphire Scout." },

  { id:"purple-pineapple", name:"Purple Pineapple", type:"hybrid",
    parents:["Purple Punch","Pineapple"],
    grandparents:{"Purple Punch":["Larry OG","Granddaddy Purple"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"USA",
    terpenes:["Limonene","Myrcene","Caryophyllene"],
    effects:["Relaxed","Happy","Uplifted","Euphoric"],
    flavors:["Pineapple","Tropical","Berry","Sweet"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Purple Punch × Pineapple cross that produces colorful, fruit-forward flowers. Used as the mother in Exotic Genetix's Strawnapple." },

  { id:"garry-poppins", name:"Garry Poppins", type:"hybrid",
    parents:["Sundae Driver","Trop Cookies"],
    grandparents:{"Sundae Driver":["Fruity Pebbles OG","Grape Pie"],"Trop Cookies":["Tropicana Cookies","GSC"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Exotic Genetix", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Sweet","Cream","Cookie","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"An Exotic Genetix cross of Sundae Driver with Trop Cookies. Used as the father in Strawnapple." },

  { id:"trop-cookies", name:"Trop Cookies", aka:"Tropicana Cookies F2", type:"hybrid",
    parents:["Tropicana Cookies","GSC"],
    grandparents:{"Tropicana Cookies":["Tangie","GSC Forum cut"],"GSC":["OG Kush","Durban Poison"]},
    thc:"20-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"USA",
    terpenes:["Limonene","Caryophyllene","Myrcene"],
    effects:["Happy","Uplifted","Relaxed","Creative"],
    flavors:["Citrus","Cookie","Sweet","Tropical"],
    medical:["Stress","Anxiety","Depression","Pain"],
    desc:"A Tropicana Cookies × GSC cross used as a parent in Exotic Genetix's Garry Poppins." },

  { id:"larry-og-bx2", name:"Larry OG BX2", type:"indica",
    parents:["Larry OG","Larry OG BX1"],
    grandparents:{"Larry OG":["OG Kush","SFV OG Kush"],"Larry OG BX1":["Larry OG"]},
    thc:"22-26%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Aficionado (Leo Stone)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Pinene"],
    effects:["Relaxed","Sleepy","Euphoric","Happy"],
    flavors:["Lemon","Pine","Earth","Fuel"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"Leo Stone's second-generation backcross of Larry OG, deepening the Larry OG dominance through the BX line. Used as the father in Aficionado's Voodoo Larry release." },

  { id:"larry-og-bx3", name:"Larry OG BX3", type:"indica",
    parents:["Lemon Larry OG","SFV OG"],
    grandparents:{"Lemon Larry OG":["OG Kush","SFV OG Kush"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Aficionado (Leo Stone)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Lemon","Pine","Earth","Fuel"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"Leo Stone's third-generation backcross of Larry OG, combining Lemon Larry OG with SFV OG. Used as the father in Aficionado's Rainbow Larry." },

  { id:"zoap", name:"Zoap", type:"hybrid",
    parents:["Pink Guava","Rainbow Sherbet 11"],
    grandparents:{"Pink Guava":["Guava","Pink Phenotype"],"Rainbow Sherbet 11":["Rainbow Sherbet"]},
    thc:"22-28%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Lit Farms", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Linalool"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Soap","Floral","Sweet","Tropical"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"Lit Farms' celebrated 'Zoap' release combining Pink Guava with RS11. Known for its distinctive soapy-floral aromatic. Used as the father in Lit Farms' 1969." },

  { id:"pink-guava", name:"Pink Guava", type:"hybrid",
    parents:["Guava","Pink Phenotype"],
    grandparents:{},
    thc:"19-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"USA",
    terpenes:["Limonene","Caryophyllene","Myrcene"],
    effects:["Happy","Uplifted","Relaxed","Creative"],
    flavors:["Guava","Tropical","Sweet","Floral"],
    medical:["Stress","Anxiety","Depression","Pain"],
    desc:"A boutique tropical-fruit cross known for its bright pink pistils and distinctive guava aromatic. Used as a parent in both Wizard Trees' RS11 and Lit Farms' Zoap." },

  { id:"2090-shit", name:"2090 Sh*t", type:"indica",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Lit Farms", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Lit Farms internal selection used as the mother in their 1969 release. Specific lineage details not publicly documented." },

  { id:"mind-flayer", name:"Mind Flayer", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Solfire Gardens", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Solfire Gardens breeding line referenced as a parent in Lung Buster, Udder Madness, and Mind Melter." },

  { id:"bitties", name:"Bitties", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Solfire Gardens", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Solfire Gardens breeding line. Specific lineage not publicly documented." },

  { id:"los-celos", name:"Los Celos", type:"hybrid",
    parents:["Umami","Saherbinski"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Fat Cat Seeds", origin:"Maine, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Fat Cat Seeds Umami × Saherbinski cross used as the mother in their El Cielo release." },

  { id:"saherbinski", name:"Saherbinski", type:"hybrid",
    parents:["Sunset Sherbet","Zuchi"],
    grandparents:{"Sunset Sherbet":["GSC","Pink Panties"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Fat Cat Seeds (attributed)", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Sunset Sherbet × Zuchi cross used as a grandparent in Fat Cat's El Cielo line." },

  { id:"umami", name:"Umami", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A breeding line used as a grandparent in Fat Cat Seeds' Los Celos. Specific lineage not publicly documented." },

  { id:"zuchi", name:"Zuchi", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A breeding line used as a grandparent in Fat Cat Seeds' Saherbinski cross. Specific lineage not publicly documented." },

  { id:"3-kings", name:"3 Kings", type:"hybrid",
    parents:["Headband","Sour Diesel","OG Kush"],
    grandparents:{"Sour Diesel":["Chemdawg 91","Super Skunk"],"OG Kush":["Chemdawg","Hindu Kush"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Royal Choice Farms", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Pinene"],
    effects:["Relaxed","Happy","Euphoric","Creative"],
    flavors:["Diesel","Pine","Earth","Fuel"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A three-way cross stacking Headband, Sour Diesel, and OG Kush. Used as a parent in Fat Cat Seeds' Crumpets line." },

  { id:"blue-grease", name:"Blue Grease", type:"hybrid",
    parents:["Grease","Blueberry (DJ Short)"],
    grandparents:{"Blueberry (DJ Short)":["Afghani","Thai","Purple Thai"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Grease × Blueberry cross used as a grandparent in Fat Cat Seeds' Grease Fire." },

  { id:"gorilla-fire", name:"Gorilla Fire", type:"hybrid",
    parents:["Gorilla Glue #4","Fire OG"],
    grandparents:{"Gorilla Glue #4":["Chem's Sister","Chocolate Diesel","Sour Dubb"],"Fire OG":["OG Kush","SFV OG Kush"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Heritage cut", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Euphoric","Sleepy"],
    flavors:["Diesel","Pine","Earth","Fuel"],
    medical:["Pain","Stress","Insomnia","Anxiety"],
    desc:"A GG4 × Fire OG cross used as the father in Fat Cat Seeds' Grease Fire." },

  { id:"menemsha-sunset", name:"Menemsha Sunset", type:"hybrid",
    parents:["Purple Tangie","Red Spangled Banner"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Fat Cat Seeds", origin:"Maine, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Fat Cat Seeds Purple Tangie × Red Spangled Banner cross used as a parent in their Menemsha Sunset × Rumcakez release." },

  { id:"purple-tangie", name:"Purple Tangie", type:"hybrid",
    parents:["Tangie phenotype","Purple phenotype"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A purple-leaning Tangie phenotype used as a grandparent in Fat Cat's Menemsha Sunset line." },

  { id:"red-spangled-banner", name:"Red Spangled Banner", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Fat Cat Seeds", origin:"Maine, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Fat Cat Seeds breeding line used as a grandparent in Menemsha Sunset. Specific lineage not publicly documented." },

  { id:"rumcakez", name:"Rumcakez", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Fat Cat Seeds", origin:"Maine, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Fat Cat Seeds breeding line used as a parent in their Menemsha Sunset × Rumcakez and Rumchata releases. Specific lineage not publicly documented." },

  { id:"sweet-jack-haze", name:"Sweet Jack Haze", type:"sativa",
    parents:["Jack Herer","Sweet phenotype"],
    grandparents:{"Jack Herer":["Northern Lights #5","Shiva Skunk","Haze"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Jack Herer-derived sativa used as the mother in Dank Flow Genetics' Good Karma." },

  { id:"monty-gluethon", name:"Monty Gluethon", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Dank Flow Genetics", origin:"Massachusetts, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Dank Flow Genetics breeding line used as the father in their Good Karma feminized release. Specific lineage not publicly documented." },

  { id:"third-leg", name:"Third Leg", type:"hybrid",
    parents:["Salami Glue","Salami Leg"],
    grandparents:{"Salami Glue":["Gorilla Glue #4","Salami Leg"],"Salami Leg":["Romberry","Garlic Breath"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Dank Flow Genetics", origin:"Massachusetts, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Dank Flow Genetics Salami Glue × Salami Leg cross used as the father in Ridge Town." },

  { id:"salami-glue", name:"Salami Glue", type:"hybrid",
    parents:["Gorilla Glue #4","Salami Leg"],
    grandparents:{"Gorilla Glue #4":["Chem's Sister","Chocolate Diesel","Sour Dubb"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Dank Flow Genetics", origin:"Massachusetts, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Dank Flow Genetics GG4 × Salami Leg cross used as a grandparent in Third Leg / Ridge Town." },

  { id:"salami-leg", name:"Salami Leg", type:"hybrid",
    parents:["Romberry","Garlic Breath"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Dank Flow Genetics", origin:"Massachusetts, USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Dank Flow Genetics Romberry × Garlic Breath cross used as a parent in Salami Glue and the Third Leg / Ridge Town line." },

  { id:"slurricane", name:"Slurricane", type:"indica",
    parents:["Do-Si-Dos","Purple Punch"],
    grandparents:{"Do-Si-Dos":["GSC","Face Off OG"],"Purple Punch":["Larry OG","Granddaddy Purple"]},
    thc:"22-27%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"In House Genetics", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Linalool"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Berry","Sweet","Grape","Earth"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"In House Genetics' celebrated Do-Si-Dos × Purple Punch cross. A foundational modern dessert-indica parent and a component in Sunken Treasure's Slimeball line." },

  { id:"grape-balls-of-fire", name:"Grape Balls of Fire", type:"hybrid",
    parents:["Grape Stomper","Fire OG"],
    grandparents:{"Grape Stomper":["Sour Diesel","Purple Elephant"],"Fire OG":["OG Kush","SFV OG Kush"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Grape Stomper × Fire OG cross used as a grandparent in Sunken Treasure's Slimeball #3 line." },

  { id:"legend-orange-apricot-f2", name:"Legend Orange Apricot F2", aka:"LOA F2", type:"hybrid",
    parents:["Legend Orange Apricot"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A second-generation selection of the Legend Orange Apricot line. Used as a parent in Phenohuntr's Ogeeze." },

  { id:"ogeeze", name:"Ogeeze", type:"hybrid",
    parents:["Legend Orange Apricot F2","Oz Kush"],
    grandparents:{"Oz Kush":["OG Eddy Lepp","Zkittlez"]},
    thc:"", cbd:"", flowering:"",
    breeder:"Phenohuntr / Green Lab Genetics", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Phenohuntr / Green Lab Genetics cross stacking Legend Orange Apricot F2 with Oz Kush. Used as the father in Slimeball #3 × Ogeeze." },

  { id:"blue-heron-111", name:"Blue Heron #111", type:"hybrid",
    parents:["Blue Heron"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Dynasty Genetics", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Dynasty Genetics #111 phenotype selection from their Blue Heron line. Used as the father in Black Blu Magoo." },

  { id:"blue-magoo", name:"Blue Magoo", type:"hybrid",
    parents:["DJ Short Blueberry","William's Wonder F2"],
    grandparents:{"DJ Short Blueberry":["Afghani","Thai","Purple Thai"]},
    thc:"17-21%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Dynasty Genetics", origin:"USA",
    terpenes:["Myrcene","Caryophyllene","Linalool"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Berry","Blueberry","Sweet","Floral"],
    medical:["Stress","Pain","Insomnia","Anxiety"],
    desc:"Dynasty Genetics' celebrated DJ Short Blueberry × William's Wonder F2 cross. A foundational Dynasty release with intense blueberry aromatics." },

  { id:"puna-diesel", name:"Puna Diesel", type:"sativa",
    parents:["Hawaiian","Sour Diesel"],
    grandparents:{"Sour Diesel":["Chemdawg 91","Super Skunk"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"63-77 days",
    breeder:"Hawaiian Budline (heritage)", origin:"Big Island, Hawaii",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Energetic","Happy","Uplifted","Creative"],
    flavors:["Diesel","Tropical","Citrus","Sweet"],
    medical:["Depression","Stress","Fatigue","Pain"],
    desc:"A Big Island heritage Hawaiian × Sour Diesel cross, named for the Puna district. Used as the mother in Hawaiian Budline's Puna Cherry D." },

  { id:"glazed-cherries-f5", name:"Glazed Cherries F5", type:"hybrid",
    parents:["Glazed Cherries"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Heritage cut", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A fifth-generation selection of the Glazed Cherries line. Used as the father in Hawaiian Budline's Puna Cherry D." },

  { id:"hells-angel-og", name:"Hells Angel OG", aka:"HA-OG", type:"indica",
    parents:["OG Kush phenotype"],
    grandparents:{"OG Kush phenotype":["Chemdawg","Hindu Kush"]},
    thc:"21-25%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Cali Connection (heritage cut)", origin:"USA",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Sleepy","Happy","Euphoric"],
    flavors:["Pine","Earth","Lemon","Fuel"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"A heritage OG Kush phenotype circulating in the California clone scene. Used as a parent in Karma Genetics' Biker Kush V1.0 line." },

  { id:"lucky-charms", name:"Lucky Charms", type:"hybrid",
    parents:["Triangle Kush","The White","Appalachia"],
    grandparents:{"Triangle Kush":["OG Kush"],"Appalachia":["Tres Dawg","Green Crack"]},
    thc:"19-23%", cbd:"<0.5%", flowering:"56-63 days",
    breeder:"Bodhi Seeds", origin:"USA",
    terpenes:["Caryophyllene","Pinene","Myrcene"],
    effects:["Happy","Relaxed","Euphoric","Creative"],
    flavors:["Earth","Pine","Sweet","Citrus"],
    medical:["Stress","Pain","Anxiety","Depression"],
    desc:"A Bodhi Seeds release combining Triangle Kush, The White, and Appalachia. Used as a grandparent in Karma Genetics' Biker Kush line." },

  { id:"biker-kush-v1", name:"Biker Kush V1.0", aka:"HA-OG BX1", type:"indica",
    parents:["Hells Angel OG","Lucky Charms"],
    grandparents:{"Hells Angel OG":["OG Kush phenotype"],"Lucky Charms":["Triangle Kush","The White","Appalachia"]},
    thc:"20-24%", cbd:"<0.1%", flowering:"56-63 days",
    breeder:"Karma Genetics", origin:"Netherlands",
    terpenes:["Caryophyllene","Limonene","Myrcene"],
    effects:["Relaxed","Happy","Sleepy","Euphoric"],
    flavors:["Earth","Pine","Fuel","Sweet"],
    medical:["Pain","Insomnia","Stress","Anxiety"],
    desc:"Karma Genetics' Biker Kush V1.0, also known as HA-OG BX1. Used as a parent in the Cheesy Rider bagseed line." },

  { id:"purple-panty-dropper", name:"Purple Panty Dropper", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Rainbow House Seed Co", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Rainbow House Seed Co breeding line used as a parent in their Rainbow Panty Dropper F1 release. Specific lineage not publicly documented." },

  { id:"nami", name:"Nami", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Gage Green Group (tester)", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A Gage Green Group tester used as the father in Starlabs' Grape Nami. Specific lineage not publicly documented." },

  { id:"han-solo-hashplant", name:"Han Solo Hashplant", type:"hybrid",
    parents:["Hashplant phenotype"],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Aaron (heritage cut)", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A heritage Hashplant cut from breeder Aaron, used as the father in Starlabs' Grape Han. Specific lineage not publicly documented." },

  { id:"datura", name:"Datura", type:"hybrid",
    parents:["",""],
    grandparents:{},
    thc:"", cbd:"", flowering:"",
    breeder:"Pacha's Select / Swamp Boys (attributed)", origin:"USA",
    terpenes:[],
    effects:[],
    flavors:[],
    medical:[],
    desc:"A breeding line used as the father in Pacha's Select Florida Man. Specific lineage not publicly documented." }

]);